import React from 'react'
import { mapDataForUser } from '../../app/modules/apps/data-administration/data-admininstration-list/form-edit-modal/FacilitiesModalForm'
import { generateAddress } from './addressGenarator'
import ImageLightBox from './components/ImageLightBox'
import { configCategoryMap } from './dataExamples'
import DdpC from './DdpC'
import { getCategoryName } from '../../app/modules/apps/settings/settting-modules/sub-category-wrapper/categoryHelper'
import { useState } from 'react'
import { UserEditModal } from '../../app/modules/apps/data-administration/data-admininstration-list/form-edit-modal/CoomonEditModal'
import { KTIcon } from './components/KTIcon'

const configMapData = configCategoryMap

const accessNestedProperty = (obj, path) => {
  return path.split('[').reduce((acc, key) => {
    return acc && acc[key.replace(']', '')]
  }, obj)
}

export const HelloTesting = (passData: any) => {
  const {
    user,
    mapData,
    pathname,
    isPartner,
    itemIdForUpdate,
    assignAuditor,
    setShowMapModal,
    lightBoxRef,
    setshowImageModal,
  } = passData

  const showIncentiveTiers = {
    SMALL_ICELAND: "Small Island",
    SMALL_MH: "Small Material Hub",
    MEDIUM_MH: "Medium Material Hub",
    LARGE_MH: "Large Material Hub",
  }


  // Add this where you handle other modals (probably near existing modal rendering)




  if (mapData.includes('[')) return clipText(accessNestedProperty(user, mapData), 30)
  switch (mapData) {
    case 'categoryItem':
      return (user?.categoryName ?? '') + ' ' + (user.itemName ?? '')
    case 'linkedCustomerName':
      return (
        <div dangerouslySetInnerHTML={{ __html: user?.linkedCustomerName?.join(',<br/>') ?? '' }} />
      )

    case 'linkedPickupPointName':
      return (
        <div
          dangerouslySetInnerHTML={{ __html: user?.linkedPickupPointName?.join(',<br/>') ?? '' }}
        />
      )
    case 'sponsorDate':
      return (
        user?.sponsorDetails
          ?.map((eachSpn) => new Date(eachSpn?.date)?.toLocaleDateString())
          .join(' , ') || '-'
      )

    case "sponsorNamet":
      return user.sponsorName


    case "feedstockpos":
      if (user.sourceMaterial) {
        // Remove the triple brackets and split by comma
        const materials = user.sourceMaterial
          .replace(/\[|\]/g, '') // Remove all brackets
          .split(',')
          .map(material => material.trim()) // Remove extra spaces
          .filter(material => material.length > 0); // Remove empty strings

        return (
          <div>
            {materials.map((material, index) => (
              <div key={index} style={{ whiteSpace: 'nowrap' }}>
                {material}
              </div>
            ))}
          </div>
        );
      }
      return user.sourceMaterial;

    case "creationDatett":
      return "-"


    case "completionDatett":
      return new Date(user.completionDate).toISOString().slice(0, 10).replace(/-/g, '/');



    case 'sponsorName':
      return user?.sponsorDetails?.map((eachSpn) => eachSpn?.sponsorName).join(',') || '-'

    case "couponIcon":
      return (
        <img
          src={user?.couponIcon}
          alt="coupon"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/icons8-error-64.png';
          }}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
      );


    case "couponSupplyChain":
      return (
        <div>
          {user?.availableFranchisee?.map((franchiseeId: string) => (
            <div key={franchiseeId}>
              {franchiseeId}
            </div>
          ))}
        </div>
      );

    // case "sponsorNameR":
    //   return user?.sponsorName
    //   user.sponsorKycDetails[0].docUrl

    case "sponsorNameR":
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            // whiteSpace: 'nowrap',
          }}
        >
          {user?.sponsorKycDetails?.[0]?.docUrl && (
            <img
              src={user.sponsorKycDetails[0].docUrl}
              alt="KYC Document"
              style={{
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '1px solid #ccc',
              }}
            />
          )}
          <span style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>
            {user?.sponsorName}
          </span>
        </div>
      );







    case "pickupPointNameR":
      return user?.pickupPointName
    case 'auditorNames':
      return user.auditorName || '-'
    case 'auditorName':
      return isPartner ? (
        user[mapData] ? (
          clipText(user[mapData], 10)
        ) : (
          <div
            className='text-red-500'
            onClick={async () =>
              pathname === '/apps/plastic-credits/unaudited'
                ? await assignAuditor.mutateAsync(user[mapData])
                : false
            }
          >
            {pathname === '/apps/plastic-credits/unaudited' ? ' Click to assign' : '-'}
          </div>
        )
      ) : (
        user[mapData]
      )
    case 'franchises':
      return user?.[mapData]?.map((y) => y?.name).join(' , ') ?? ''
    case 'facilityManagers':
      return user?.[mapData]?.map((y) => y?.name).join(' , ') ?? ''
    case 'categoryName-c':
    case 'itemName-c':
    case 'itemQuantity-c':
    case 'co2savings-c':
    case 'energySavings-c':
    case 'waterSavings-c':
    case 'treeSavings-c':
      return typeof user?.[mapData.split('-')?.[0]] === 'number'
        ? user?.[mapData.split('-')?.[0]]?.toFixed(2)
        : user?.[mapData.split('-')[0]] ?? ''
    case 'description':
      return user.description || ''
    case 'test':
      return user?.tests?.[0]?.testName || '-'
    case 'B2B':
      return user.wasteSource === mapData ? user.pickupPointName : user?.customerInfo?.name
    case 'BLOCKCHAIN':
    case 'COLLECT':
    case 'PROCESSING':
    case 'SUPPLY':
    case 'RECEIVE':
    case 'DPP':
    case 'PLASTIC_CREDITS':
      return user?.detail?.map((x: any) => (x?.transactionName === mapData ? x.price : ''))
    case 'mapLocation':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowMapModal({
              show: true,
              clicked: mapData,
            })
          }}
        >
          {user.latitude ? 'click to view' : '-'}
        </div>
      )
    case 'sankey':
    case 'viewBill':
    case 'co2Savings':
      const hasData = user.co2Savings && user.co2Savings !== 0 &&
        user.waterSavings && user.waterSavings !== 0 &&
        user.energySavings && user.energySavings !== 0 &&
        user.treeSavings && user.treeSavings !== 0;

      return (
        <div
          onClick={() => {
            if (hasData) {
              setshowImageModal({
                show: true,
                clicked: mapData,
              });
            }
          }}
          style={{
            cursor: hasData ? 'pointer' : 'not-allowed',
            opacity: hasData ? 1 : 0.5,
            color: hasData ? 'inherit' : '#999'
          }}
        >
          Click to view
        </div>
      )




    case 'couponRewards':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }}
        >
          Click to view
        </div>
      )

    case 'MThubs':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }}
        >
          Click to view
        </div>
      )


    case 'B2B1':
      return user.wasteSource === 'B2B' ? user.fromPickupPointName :
        (user.wasteSource === mapData ? user.pickupPointName : user?.customerInfo?.name)





    case 'certification_table':
    case 'weightscale_table':
    case 'analytics_table':
    // case 'bom':
    //   const isBom = mapData === 'bom';
    //   const isWeightScale = mapData === 'weightscale_table';

    //   const hasData1 = isBom
    //     ? user?.bomDetails?.length > 0
    //     : isWeightScale
    //       ? user?.weightScale // Check if weightScale exists
    //       : true; // For certification_table and analytics_table, always show

    //   return (
    //     <div
    //       className={
    //         (!hasData1 && 'cursor-not-allowed opacity-25') || ''
    //       }
    //       // style={{
    //       //   color: hasData1 ? '#12B886' : '#999'
    //       // }}
    //       onClick={() =>
    //         hasData1
    //           ? setshowImageModal({
    //             show: true,
    //             clicked: mapData,
    //           })
    //           : ''
    //       }
    //     >
    //       Click to view
    //     </div>
    //   )
    case 'bom':
      const isBom = mapData === 'bom';
      const isWeightScale = mapData === 'weightscale_table';
      const isCertification = mapData === 'certification_table';

      const hasData1 = isBom
        ? user?.bomDetails?.length > 0
        : isWeightScale
          ? user?.weightScale // Check if weightScale exists
          : isCertification
            ? user?.certifications?.length > 0 // Check if certifications array has data
            : true; // For analytics_table, always show

      return (
        <div
          className={
            (!hasData1 && 'cursor-not-allowed opacity-25') || ''
          }
          // style={{
          //   color: hasData1 ? '#12B886' : '#999'
          // }}
          onClick={() =>
            hasData1
              ? setshowImageModal({
                show: true,
                clicked: mapData,
              })
              : ''
          }
        >
          Click to view
        </div>
      )

    case 'receipt':
      return user.transactionType === 'DR' ? (
        <div style={{ position: 'relative' }}>
          <div
            className='cursor-pointer text-primary hover:text-primary-dark'
            onClick={(e) => {
              const popup = e.currentTarget.nextElementSibling as HTMLElement | null
              if (popup) {
                popup.style.display = popup.style.display === 'none' ? 'flex' : 'none'
              }
            }}
          >
            Click to view
          </div>

          {/* Larger modal container - initially hidden */}
          <div
            style={{
              display: 'none', // Initially hidden
              position: 'fixed',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1000,
              justifyContent: 'center', // Center horizontally
              alignItems: 'center', // Center vertically
              color: '#333',
            }}
          >
            {/* Modal content */}
            <div
              style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                width: '500px',
                maxWidth: '90%',
                maxHeight: '90vh',
                overflow: 'auto',
                position: 'relative',
                padding: '25px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
              }}
            >
              {/* Close button */}
              <div
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  cursor: 'pointer',
                  fontSize: '20px',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1,
                }}
                onClick={(e) => {
                  const modalElement = e.currentTarget.closest('[style*="position: fixed"]')
                  if (modalElement) {
                    ; (modalElement as HTMLElement).style.display = 'none'
                  }
                }}
              >
                ×
              </div>

              {/* Modal title */}
              <div
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  marginBottom: '20px',
                  textAlign: 'center',
                  color: '#333',
                }}
              >
                Receipt Details
              </div>

              {/* Receipt template centered in the modal */}
              <div
                style={{
                  width: '80mm',
                  border: '1px solid #ccc',
                  padding: '10px',
                  fontFamily: 'Arial, sans-serif',
                  boxSizing: 'border-box',
                  position: 'relative',
                  margin: '0 auto',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                }}
              >
                {/* Receipt content - same as before */}
                {/* Logo */}
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '24px',
                    color: '#666',
                    marginTop: '15px',
                    marginBottom: '25px',
                  }}
                >
                  LOGO
                </div>

                {/* Date */}
                <div
                  style={{
                    marginBottom: '12px',
                    color: '#666',
                    fontSize: '12px',
                  }}
                >
                  Date: {new Date().toLocaleDateString()}
                </div>

                {/* Transaction id */}
                <div
                  style={{
                    backgroundColor: '#f0f0f0',
                    padding: '10px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    marginBottom: '25px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }}
                >
                  TXN ID: {user.id || user.transactionId || 'TXN12345'}
                </div>

                {/* Receipt/Payment Header */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '5px',
                    fontSize: '12px',
                    color: '#666',
                  }}
                >
                  <div>Receipt</div>
                  <div>Payment</div>
                </div>

                {/* Separator line */}
                <div
                  style={{
                    height: '1px',
                    backgroundColor: '#ccc',
                    marginBottom: '12px',
                  }}
                ></div>

                {/* Supplier Info */}
                <div
                  style={{
                    marginBottom: '10px',
                    fontSize: '12px',
                  }}
                >
                  <div
                    style={{
                      marginBottom: '8px',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>Supplier name:</span>
                    <span>{user?.name || user?.supplierName || 'Supplier'}</span>
                  </div>
                  <div
                    style={{
                      marginBottom: '8px',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>Type:</span>
                    <span>{user.type || 'DR'}</span>
                  </div>
                  <div
                    style={{
                      marginBottom: '8px',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>Amount:</span>
                    <span>{user.amount || '$25.00'}</span>
                  </div>
                </div>

                {/* Separator line */}
                <div
                  style={{
                    height: '1px',
                    backgroundColor: '#ccc',
                    marginBottom: '35px',
                  }}
                ></div>

                {/* QR Code */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '15px',
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#f0f0f0',
                      padding: '10px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      width: '120px',
                      height: '120px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '12px',
                    }}
                  >
                    QR Code - Link to image URL
                  </div>
                </div>

                {/* Footer logo */}
                {/* <div style={{
                  textAlign: 'center',
                  fontSize: '16px',
                  color: '#666',
                  marginBottom: '5px'
                }}>
                  Inclusiv logo
                </div> */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <img
                    alt='Logo'
                    src='/media/logos/enverify-logo-black.png'
                    style={{ width: '100px', height: 'auto' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null

    case 'pickupointId':
      return user[mapData].map((x) => x?.pickupPointName)
    case 'transactionType':
      return (
        <span
          className={`badge badge-light-${user.transactionType !== 'DR' ? 'primary' : 'success'
            } fs-7 fw-bold`}
        >
          {user.transactionType}
        </span>
      )
    case 'rigid-badge':
      return (
        <span className={`badge badge-primary-success fs-7 fw-bold`}>
          {user?.diversionCapacity?.filter((x) => x?.name?.toLowerCase() === 'rigid')?.[0]
            ?.capacity * 1000 || '-'}
        </span>
      )
    case 'rigid':
      return (
        <span className={`badge badge-light-primary fs-7 fw-bold`}>
          {user?.diversionCapacity?.filter((x) => x?.name?.toLowerCase() === mapData)?.[0]
            ?.capacity * 1000 || '-'}
        </span>
      )

    case 'rigidcc':
      return (
        <span className={`badge badge-light-primary fs-7 fw-bold`}>
          {user?.processingCapacity}
        </span>
      )
    case 'flexible':
      return user?.diversionCapacity?.filter((x) => x?.name === mapData)?.[0]?.capacity || '-'
    case 'locationName':
      return (
        <span className='badge badge-light-info fs-7 fw-bold'>
          {user?.personalDetails?.name || ''}
        </span>
      )

    // case 'facilityType':
    //   return user?.facilityType?.length
    //     ? user.facilityType.map((type) => (
    //       <span className='badge badge-light-info fs-7 fw-bold' key={type}>
    //         {mapDataForUser[type] || type}
    //         <br />
    //       </span>
    //     ))
    //     : user?.facilityType?.toUpperCase()


    // 

    case "mirating":
      if (!user.rating) {
        return <span>-</span>
      }

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div style={{
            position: 'relative',
            display: 'inline-block',
            fontSize: '18px',
            lineHeight: 1
          }}>
            {/* Gray background star */}
            <span style={{ color: '#E0E0E0' }}>★</span>
            {/* Yellow half overlay */}
            <span style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '50%',
              overflow: 'hidden',
              color: '#FFC107'
            }}>★</span>
          </div>
          <span style={{ fontWeight: 'bold' }}>{user.rating}</span>
        </div>
      )



    // case 'facilityType':
    //   return (() => {
    //     const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    //     const segmentType = authData?.data?.segmentType;
    //     if (segmentType === "BIOFUEL") {
    //       const facilityTypeMap = {
    //         "MRF": "Trader with Storage",
    //         "DIVERSION_FACILITY": "Biomethane Unit",
    //         "AGGREGATOR": "Biogas Unit",
    //         "COLLECTION_TYPE": "First Gathering Point/ Collection Point",
    //         "CONVERTER": "End User"
    //       };
    //       return user?.facilityType?.map((type) => (
    //         <span className='badge badge-light-info fs-7 fw-bold' key={type}>
    //           {facilityTypeMap[type] || type}
    //           <br />
    //         </span>
    //       ));
    //     } else {
    //       return user?.facilityType?.length
    //         ? user.facilityType.map((type) => (
    //           <span className='badge badge-light-info fs-7 fw-bold' key={type}>
    //             {mapDataForUser[type] || type}
    //             <br />
    //           </span>
    //         ))
    //         : user?.facilityType?.toUpperCase();
    //     }
    //   })();



    // case 'facilityType':
    //   return (() => {
    //     const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    //     const segmentType = authData?.data?.segmentType;

    //     // Define the mapping function
    //     const getFacilityLabel = (type) => {
    //       if (segmentType === "BIOFUEL") {
    //         const facilityTypeMap = {
    //           "MRF": "Trader with Storage",
    //           "DIVERSION_FACILITY": "Biomethane Unit",
    //           "AGGREGATOR": "Biogas Unit",
    //           "COLLECTION_TYPE": "First Gathering Point/ Collection Point",
    //           "CONVERTER": "End User"
    //         };
    //         return facilityTypeMap[type] || type;
    //       } else {
    //         // Use the same logic as dropdown
    //         if (type === 'COLLECTION_TYPE') {
    //           return 'UBS';
    //         } else if (type === 'AGGREGATOR') {
    //           return 'Waste Bank';
    //         } else if (type === 'FLEET') {
    //           return 'FTS Collection Ecosystem';
    //         } else {
    //           return mapDataForUser[type] || type;
    //         }
    //       }
    //     };

    //     return user?.facilityType?.length
    //       ? user.facilityType.map((type) => (
    //         <span className='badge badge-light-info fs-7 fw-bold' key={type}>
    //           {getFacilityLabel(type)}
    //           <br />
    //         </span>
    //       ))
    //       : user?.facilityType ? user?.facilityType?.toUpperCase() : '';
    //   })();


    case 'facilityType':
      return (() => {
        const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
        const segmentType = authData?.data?.segmentType;

        const getFacilityLabel = (type) => {
          if (segmentType === "BIOFUEL") {
            const facilityTypeMap = {
              "MRF": "Trader with Storage",
              "DIVERSION_FACILITY": "Biomethane Unit",
              "AGGREGATOR": "Biogas Unit",
              "COLLECTION_TYPE": "First Gathering Point/ Collection Point",
              "CONVERTER": "End User"
            };
            return facilityTypeMap[type] || type;
          } else {
            if (type === 'COLLECTION_TYPE') {
              return 'UBS';
            } else if (type === 'AGGREGATOR') {
              return 'Waste Bank';
            } else if (type === 'FLEET') {
              return 'FTS Collection Ecosystem';
            } else {
              return mapDataForUser[type] || type;
            }
          }
        };

        return user?.facilityType?.length ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
            {user.facilityType.map((type) => (
              <span className='badge badge-light-info fs-7 fw-bold' key={type}>
                {getFacilityLabel(type)}
              </span>
            ))}
          </div>
        ) : user?.facilityType ? user?.facilityType?.toUpperCase() : '';
      })();

    case "Sourceiscc":
      return user?.customerInfo?.name
    case "Cultivation":
      return user?.isccEu?.eec?.value != null ? Number(user.isccEu.eec.value).toFixed(2) : null;
    case "LandUse":
      return user?.isccEu?.el?.value != null ? Number(user.isccEu.el.value).toFixed(2) : null;
    case "soilCarbon":
      return user?.isccEu?.esca?.value != null ? Number(user.isccEu.esca.value).toFixed(2) : null;
    case "Methane":
      return user?.isccEu?.methaneCredit?.value != null ? Number(user.isccEu.methaneCredit.value).toFixed(2) : null;

    case "EnergyC":
      return user?.isccEu?.lhv?.value != null ? Number(user.isccEu.lhv.value).toFixed(2) : null;
    case "EpV":
      return user?.isccEu?.ep?.value
    case "GHg":
      return user?.isccEu?.ep?.type

    case "totalV":
      const eec = user?.isccEu?.eec?.value != null ? Number(user.isccEu.eec.value) : 0;
      const el = user?.isccEu?.el?.value != null ? Number(user.isccEu.el.value) : 0;
      const esca = user?.isccEu?.esca?.value != null ? Number(user.isccEu.esca.value) : 0;
      const methaneCredit = user?.isccEu?.methaneCredit?.value != null ? Number(user.isccEu.methaneCredit.value) : 0;
      const etdCollect = user?.isccEu?.etdCollect?.value != null ? Number(user.isccEu.etdCollect.value) : 0;
      const total = eec + el + esca + methaneCredit + etdCollect;
      return (
        <span className={`badge badge-light-info fs-7 fw-bold`}>
          {total.toFixed(2)}
        </span>
      );


    case "userRole":
      return (
        <span className='badge badge-light-info fs-7 fw-bold' style={{
          backgroundColor: '#f8f5ff',
          color: '#7239ea',
        }}>
          {user.userType === "FRANCHISE_USER"
            ? "Supply chain manager"
            : user.userType === "CLIENT_USER"
              ? "Marketing manager"
              : user.userType === "MARKETING"
                ? "Business development"
                : user.userType}
        </span>
      )

    case "userStatus":
      return (
        <span className='badge badge-light-info fs-7 fw-bold' style={{
          backgroundColor: user.status === "ACTIVE" ? '#e8fff3' : '#ffeef3',
          color: user.status === "ACTIVE" ? '#50cd89' : '#f8285a',
        }}>
          {user.status}
        </span>
      )



    case "panmein":
      return user.orderDetails?.[0]?.items?.[0].itemName
    case "qtin":
      return user.orderDetails?.[0]?.items?.[0].quantity
    case "catin":
      return user.orderDetails?.[0]?.categoryName
    case "erin":
      return user.pickupInfo?.centreName
    case "inre":
      return <div
        style={{
          cursor: 'pointer',
          backgroundColor: '#defee9',
          color: '#17c653',
          fontWeight: 'bold',
          borderRadius: '6px',
          padding: '2px 2px',
          textAlign: 'center',
          display: 'inline-block',
          minWidth: '80px',
          fontSize: "12px"
        }}
      // onClick={() => handleEditClick(user)}
      >
        RECEIVED
      </div>

    case "dd":
      return user.actualSupplyDate ? new Date(user.actualSupplyDate).toLocaleDateString('en-CA').replace(/-/g, '/') : 'N/A'


    case "inghg":
      return <div className={`badge badge-light-info fs-7 fw-bold`}>
        {(
          (user.isccEu?.eec?.value ?? 0) +
          (user.isccEu?.el?.value ?? 0) +
          (user.isccEu?.esca?.value ?? 0) +
          (user.isccEu?.methaneCredit?.value ?? 0) +
          (user.isccEu?.etdCollect?.value ?? 0) +
          (user.isccEu?.etdReturn?.value ?? 0) +
          (user.isccEu?.etdConvert?.value ?? 0)
        ).toFixed(2)}
      </div>


    case "ghgpos":
      return <div className={`badge badge-light-info fs-7 fw-bold`}>
        {(
          (user.isccEu?.ghg?.value ?? 0)
        ).toFixed(2)}
      </div>

    case "apd":
      return new Date(user.actualProcessDate).toISOString().substring(0, 10).replace(/-/g, '/');


    case "pickupInfoCn":
      return user?.toPickupPointName


    case "ghgvo":
      return user.isccEu?.ghg?.value?.toFixed(2) ?? '';

    case "ocountry":
      return user?.pickupPointInfo?.address?.country

    case "osite":
      return user?.pickupPointName
    case "opname":
      return user?.productionItemDetails?.[0]?.itemName
    case "ORM":
      return user?.inputMaterial?.[0]?.inputMaterialName
    case "Suppliersssc":
      return user?.pickupPointName


    case "outQty":
      return (Number(user.productionItemDetails?.[0]?.quantity) || 0).toFixed(2)

    case "asdatepos":
      if (!user.actualSupplyDate) return '-';
      const date = new Date(user.actualSupplyDate);
      if (isNaN(date.getTime())) return '-';

      return date.toISOString().split('T')[0];

    // case "converterCountry":
    //   return user.converterAddress.country

    case "converterCountry": {
      const country = user.converterAddress?.country;
      const converterRouteLength = user.routeLength;
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '4px' }}>
          {country && <span>{country}</span>}
          {converterRouteLength && (
            <span
              style={{
                backgroundColor: '#f5f5f5',
                color: '#666',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {Number(converterRouteLength).toFixed(2)} Km
            </span>
          )}
        </div>
      );
    }
    case "converterCountry2":
      return user.pickupInfo?.address?.country
    case "pospro":
      return user.orderDetails?.[0]?.items?.[0]?.itemName
    // case "posqUANTITY":
    //   return (Number(user.orderDetails?.[0]?.items?.[0]?.quantity) || 0).toFixed(2)
    case "posqUANTITY":
      const quantity1 = (Number(user.orderDetails?.[0]?.items?.[0]?.quantity) || 0).toFixed(2);
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '4px' }}>
          {quantity1 && <span>{quantity1}</span>}
          {user.transportUsed && (
            <span
              style={{
                backgroundColor: '#f5f5f5',
                color: '#666',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {user.transportUsed.length > 10
                ? user.transportUsed.substring(0, 10) + '...'
                : user.transportUsed
              }
            </span>
          )}
        </div>
      );

    case "cityt":
      return user?.address?.city
    case "countryt":
      return user?.address?.country
    case "at":
      return user?.diversionCapacity?.map(item => `${item.capacity}`).join(", ") || "N/A";


    // case "materialNameko":
    //   return user?.productionItemDetails?.[0]?.itemName


    case "standradpic":
      const auditStandard = user?.auditStandard?.[0]; // Get first audit standard
      const logoUrl = auditStandard?.logo;

      if (!logoUrl) {
        return null; // Return nothing if no logo
      }

      return (
        <img
          src={logoUrl}
          alt={auditStandard?.name || 'Audit Standard'}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover',
            // border: '2px solid #f0f0f0'
          }}
        />
      );


    case "loginfo":
      const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      };

      return (
        <div>
          <div style={{ whiteSpace: 'nowrap' }}>
            {user.createdByName && user.createdByName.length > 10
              ? `${user.createdByName.substring(0, 10)}...`
              : user.createdByName}
          </div>
          <div style={{
            backgroundColor: '#f5f5f5',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '0.875rem',
            color: '#666',
            marginTop: '4px',
            display: 'inline-block',
            whiteSpace: 'nowrap'
          }}>
            {formatTimestamp(user.createdAt)}
          </div>
        </div>
      );

    case "Audit&company":
      const personalName = user?.auditorInfo?.personalDetails?.name;
      const companyName = user?.auditorInfo?.companyDetails?.name;

      return (
        <div>
          <div style={{ whiteSpace: 'nowrap' }}>{personalName}</div>
          <div style={{
            backgroundColor: '#f5f5f5',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '0.875rem',
            color: '#666',
            marginTop: '4px',
            display: 'inline-block'
          }}>
            {companyName}
          </div>
        </div>
      );


    case "materialNameko":
      const itemName1 = user?.productionItemDetails?.[0]?.itemName;
      const materialSum1 = user[
        mapData === 'inMaterialDetailsQuantity' ? 'inputMaterial' : 'productionItemDetails'
      ]?.reduce((sum: number, x: any) =>
        sum + (Number(x?.quantity || x?.inputQuantity) || 0), 0
      ) || 0;
      const formattedQuantity = Number(materialSum1.toFixed(2));

      return (
        <div>
          <div>{itemName1}</div>
          <div style={{
            backgroundColor: '#f5f5f5',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '0.875rem',
            color: '#666',
            marginTop: '4px',
            display: 'inline-block'
          }}>
            Qty: {formattedQuantity}
          </div>
        </div>
      );





    case "logoCommit":
      return user.sponsorLogo ? (
        <img
          src={user.sponsorLogo}
          alt="Sponsor Logo"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover',
            border: '2px solid #e9ecef'
          }}
          onError={(e) => {
            e.currentTarget.src = '/media/avatars/blank.png' // Fallback image
          }}
        />
      ) : (
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: 'gray',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          // fontWeight: 'bold',
          color: 'white'
        }}>
          {user.sponsorName ?
            user.sponsorName
              .split(' ')
              .slice(0, 2)
              .map(word => word.charAt(0).toUpperCase())
              .join('')
            : 'NA'
          }
        </div>
      )


    // ppuser
    case "ppuser":
      return user?.personalDetails?.profileImage ? (
        <img
          src={user?.personalDetails?.profileImage}
          alt="Profile"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover',
            border: '2px solid #e9ecef'
          }}
          onError={(e) => {
            e.currentTarget.src = '/media/avatars/blank.png' // Fallback image
          }}
        />
      ) : (
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: 'gray',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          color: 'white'
        }}>
          {user?.personalDetails?.name ?
            user.personalDetails.name
              .split(' ')
              .slice(0, 2)
              .map(word => word.charAt(0).toUpperCase())
              .join('')
            : 'NA'
          }
        </div>
      )


    case "Savingpos":
      const ghgValue = user?.isccEu?.ghgSaving || 0;

      // Determine colors based on value
      let textColor2, backgroundColor;
      if (ghgValue > 1) { // More than 100%
        textColor2 = 'white';
        backgroundColor = '#12b886';
      } else if (ghgValue >= 0.75) { // Between 100% - 75%
        textColor2 = '#17c653';
        backgroundColor = '#dfffea';
      } else { // Less than 75%
        textColor2 = '#f6c000';
        backgroundColor = '#fff8dd';
      }

      return (
        <div
          className={`badge badge-light-info fs-7 fw-bold`}
          style={{
            color: textColor2,
            backgroundColor: backgroundColor
          }}
        >
          {ghgValue.toFixed(2)}%
        </div>
      );


    case 'categoryMap':
      return <div>{configMapData[user.categoryId] || ''}</div>
    case 'format':
      return user.companyDetails.format || 'OWN'
    case 'personalDetail':
      return (
        <div>
          <div>{user.personalDetails?.mobile}</div>
          <div className='text-dark fw-semibold text-dark d-block fs-7'>
            {user.personalDetails?.email}
          </div>
        </div>
      )
    case 'contactDetail':
      return (
        <div>
          <div>{user.companyDetails?.mobile}</div>
          <div className='text-dark fw-semibold text-dark d-block fs-7'>
            {user.companyDetails?.email}
          </div>
        </div>
      )

    case 'Facilityt':
      return "hihihi"


    case "itemNameisscu":
      const itemName = user.orderDetails?.[0]?.items?.[0]?.itemName;
      const quantity = user.orderDetails?.[0]?.items?.[0]?.quantity;
      const unit = user.orderDetails?.[0]?.items?.[0]?.unit;

      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '4px' }}>
          <span>{itemName}</span>
          {quantity && (
            <span
              style={{
                backgroundColor: '#f5f5f5',
                color: '#666',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {quantity} {unit || 'KG'}
            </span>
          )}
        </div>
      );


    case "Transportis":
      const etdValue = user?.isccEu?.etdCollect?.value != null ? Number(user.isccEu.etdCollect.value).toFixed(4) : null;
      const routeLength = user.routeLength;

      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '4px' }}>
          {etdValue && <span>{etdValue}</span>}
          {routeLength && (
            <span
              style={{
                backgroundColor: '#f5f5f5',
                color: '#666',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: '500'
              }}
            >
              {routeLength}
            </span>
          )}
        </div>
      );

    // case 'viewddp':
    //   console.log("viewddp case triggered!"); // Add this line
    //   return (
    //     <div>
    //       <div
    //         className='cursor-pointer text-primary hover:text-primary-dark'
    //         onClick={(e) => {
    //           const popup = e.currentTarget.nextElementSibling as HTMLElement | null
    //           if (popup) {
    //             popup.style.display = popup.style.display === 'none' ? 'flex' : 'none'
    //           }
    //         }}
    //       >
    //         Click to view
    //       </div>
    //       <div
    //         style={{
    //           display: 'none',
    //           position: 'fixed',
    //           top: '0',
    //           left: '0',
    //           width: '100%',
    //           height: '100%',
    //           backgroundColor: 'rgba(0,0,0,0.5)',
    //           zIndex: 1000,
    //           overflowY: 'auto',
    //           padding: '0'
    //         }}
    //       >
    //         <div style={{
    //           backgroundColor: 'white',
    //           borderRadius: '8px',
    //           height: '100vh',
    //           overflowY: 'auto',
    //           width: '100%',
    //           maxWidth: '500px',
    //           margin: '0 auto'
    //         }}>
    //           <DdpC user={user} />
    //           <button
    //             onClick={(e) => {
    //               const modalElement = e.currentTarget.closest('[style*="position: fixed"]')
    //               if (modalElement) {
    //                 (modalElement as HTMLElement).style.display = 'none'
    //               }
    //             }}
    //           >
    //             Close
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //     )

    case 'viewddp':
      return (
        <div
          onClick={() =>
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }
        >
          Click to view
        </div>
      )




    case 'cocpopup':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            });
          }}
        >
          Click to view
        </div>
      )





    case 'commitmentEdit':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            });
          }}
        >
          <KTIcon iconName='pencil' className='fs-3' />
        </div>
      )







    case "scpic":
      const imageUrl = user.kycDocuments?.docType === "SEC_DTI" ? user.kycDocuments?.docUrl : null;

      return imageUrl ? (
        <div className="symbol symbol-45px">
          <img
            src={imageUrl}
            alt="SEC DTI Document"
            className="symbol-label bg-light-primary"
            style={{
              width: '45px',
              height: '45px',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
        </div>
      ) : (
        <div className="symbol symbol-45px">
          <div className="symbol-label bg-light-secondary">
            <span className="text-dark">N/A</span>
          </div>
        </div>
      );

    case 'viewPdf':
      const isDisabled = !user?.selfDeclarationDoc?.docUrl;
      return (
        <div
          style={{
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!isDisabled) {
              setshowImageModal({
                show: true,
                clicked: mapData,
              });
            }
          }}
        >
          <i className={`ki-duotone ki-eye fs-3 ${isDisabled ? 'text-dark' : ''}`}>
            <span className="path1"></span>
            <span className="path2"></span>
            <span className="path3"></span>
          </i>
        </div>
      )


    case "isscustatus":
      const hasDoc = user?.selfDeclarationDoc?.docUrl;
      const statusText = hasDoc ? "SD RECEIVED" : "SD PENDING";
      const bgColor = hasDoc ? "#dfffea" : "#fff8dd";
      const textColor1 = hasDoc ? "#17c653" : "#fcd41d";

      return (
        <span
          style={{
            backgroundColor: bgColor,
            color: textColor1,
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "bold"
          }}
        >
          {statusText}
        </span>
      );

    // case 'envPermit':
    //   const poiDoc = user.kycDocument?.find((doc: any) => doc.docType === 'POI');
    //   return poiDoc ? (
    //     <div className='d-flex align-items-center'>
    //       <a href={poiDoc.docUrl} target='_blank' rel='noopener noreferrer'>
    //         <div className='symbol symbol-45px me-3'>
    //           <img
    //             src={poiDoc.docUrl}
    //             alt='POI Document'
    //             className='rounded-circle'
    //             style={{ width: '45px', height: '45px', objectFit: 'cover' }}
    //           />
    //         </div>
    //       </a>
    //       <span className='text-dark fw-semibold'>
    //         {poiDoc.docNumber || 'N/A'}
    //       </span>
    //     </div>
    //   ) : (
    //     <span className='text-dark'>No POI document</span>
    //   );
    // case 'facilityPopupp':
    //   const poeDoc = user.kycDocument?.find((doc: any) => doc.docType === 'POE');
    //   return poeDoc ? (
    //     <div className='d-flex align-items-center'>
    //       <a href={poeDoc.docUrl} target='_blank' rel='noopener noreferrer'>
    //         <div className='symbol symbol-45px me-3'>
    //           <img
    //             src={poeDoc.docUrl}
    //             alt='POE Document'
    //             className='rounded-circle'
    //             style={{ width: '45px', height: '45px', objectFit: 'cover' }}
    //           />
    //         </div>
    //       </a>
    //       <span className='text-dark fw-semibold'>
    //         {poeDoc.docNumber || 'N/A'}
    //       </span>
    //     </div>
    //   ) : (
    //     <span className='text-dark'>No POE document</span>
    //   );



    case 'envPermit':
      const poiDoc = user.kycDocument?.find((doc: any) => doc.docType === 'POI');
      return poiDoc ? (
        <div className='d-flex align-items-center'>
          <a href={poiDoc.docUrl} target='_blank' rel='noopener noreferrer'>
            <div className='symbol symbol-45px me-3'>
              <img
                src={poiDoc.docUrl}
                alt='POI Document'
                className='rounded-circle'
                style={{ width: '45px', height: '45px', objectFit: 'cover' }}
                onError={(e) => {
                  e.currentTarget.src = '/icons8-error-64.png';
                }}
              />
            </div>
          </a>
          <span className='text-dark fw-semibold'>
            {poiDoc.docNumber || 'N/A'}
          </span>
        </div>
      ) : (
        <span className='text-dark'>No POI document</span>
      );

    case 'facilityPopupp':
      const poeDoc = user.kycDocument?.find((doc: any) => doc.docType === 'POE');
      return poeDoc ? (
        <div className='d-flex align-items-center'>
          <a href={poeDoc.docUrl} target='_blank' rel='noopener noreferrer'>
            <div className='symbol symbol-45px me-3'>
              <img
                src={poeDoc.docUrl}
                alt='POE Document'
                className='rounded-circle'
                style={{ width: '45px', height: '45px', objectFit: 'cover' }}
                onError={(e) => {
                  e.currentTarget.src = '/icons8-error-64.png';
                }}
              />
            </div>
          </a>
          <span className='text-dark fw-semibold'>
            {poeDoc.docNumber || 'N/A'}
          </span>
        </div>
      ) : (
        <span className='text-dark'>No POE document</span>
      );

    case "gsval":
      return (user.quantity - user.blockedQuantity).toFixed(2);








    case 'Registrypopup':
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            });
          }}
        >
          Click to view
        </div>
      )



    case 'assignDDP':
      return (
        <div
          onClick={() =>
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }
        >
          {/* Assign DPP */}
          View DPP
        </div>
      )

    case 'assignDDP2':
      return (
        <div
          onClick={() =>
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }
        >
          {/* Assign DPP */}
          View DPP
        </div>
      )

    case "WSDate":
      return new Date(user.createdAt).toISOString().split('T')[0];



    case "clink":
      return (
        <img
          src={user.image}
          alt="no img"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
      )


    case "transportType":
      if (!user || typeof user !== 'object') return '';

      const transportData: string[] = []; // Explicitly type the array
      const excludeKeys = ['id', 'basis'];

      Object.keys(user).forEach(key => {
        if (!excludeKeys.includes(key) && user[key] !== undefined && user[key] !== null) {
          transportData.push(`${key}: ${user[key]}`);
        }
      });

      return transportData.length > 0 ? transportData.join(', ') : '';


    case "basis":
      return (
        <span style={{
          backgroundColor: '#f8f5ff',
          color: '#7239ea',
          borderRadius: '6px',
          padding: '4px 8px',
          fontSize: '12px',
          fontWeight: 'bold',
        }}>
          {user.basis || 'basis'}
        </span>
      );

    case 'video_url':
      return (
        <div
          onClick={() =>
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }
        >
          Click to view
        </div>
      )







    case "ProfileLayout":
      return (
        <div className="d-flex align-items-center">
          {/* Profile Image */}
          <div className="symbol symbol-40px symbol-circle me-3">
            <div className="symbol-label">
              {user?.personalDetails?.profileImage ? (
                <img
                  src={user?.personalDetails?.profileImage}
                  alt="Profile"
                  className="w-100 h-100 rounded-circle object-cover"
                />
              ) : (
                <span className="symbol-label bg-light-primary text-primary fs-7 fw-bold">
                  {user?.personalDetails?.name
                    ?.trim()
                    .split(' ')
                    .map(word => word.charAt(0))
                    .join('')
                    .toUpperCase()
                    .slice(0, 2) || 'N/A'}
                </span>
              )}
            </div>
          </div>

          {/* Name and Email */}
          <div className="d-flex flex-column">
            <span className="text-gray-800 fw-bold fs-6 mb-1">
              {user.personalDetails.name?.trim() || 'N/A'}
            </span>
            <span className="text-dark fs-7">
              {user.personalDetails.email || 'N/A'}
            </span>
          </div>
        </div>
      );






    case 'name':
      return user?.personalDetails?.[mapData] || user?.name || ''



    // case 'name1':
    //   return (
    //     <div className="d-flex align-items-center">
    //       {/* Profile Image */}
    //       <div className="symbol symbol-40px symbol-circle me-3">
    //         <div className="symbol-label">
    //           {user?.personalDetails?.profileImage ? (
    //             <img
    //               src={user?.personalDetails?.profileImage}
    //               alt="Profile"
    //               className="w-100 h-100 rounded-circle object-cover"
    //             />
    //           ) : (
    //             <span className="symbol-label bg-light-primary text-primary fs-7 fw-bold">
    //               {(user?.personalDetails?.name || '')
    //                 ?.trim()
    //                 .split(' ')
    //                 .map(word => word.charAt(0))
    //                 .join('')
    //                 .toUpperCase()
    //                 .slice(0, 2) || 'NA'}
    //             </span>
    //           )}
    //         </div>
    //       </div>
    //       {/* Bold Name */}
    //       <span className="text-gray-800 fw-bold fs-6">
    //         {user?.personalDetails?.name || ''}
    //       </span>
    //     </div>
    //   );


    case 'name1':
      return (
        <div className="d-flex align-items-center">
          {/* Profile Image */}
          <div className="symbol symbol-40px symbol-circle me-3">
            <div className="symbol-label">
              {user?.kycDocument?.find(doc => doc.docType === "POF")?.docUrl ? (
                <img
                  src={user?.kycDocument?.find(doc => doc.docType === "POF")?.docUrl}
                  alt="Profile"
                  className="w-100 h-100 rounded-circle object-cover"
                />
              ) : (
                <span className="symbol-label bg-light-primary text-primary fs-7 fw-bold">
                  {(user?.personalDetails?.name || '')
                    ?.trim()
                    .split(' ')
                    .map(word => word.charAt(0))
                    .join('')
                    .toUpperCase()
                    .slice(0, 2) || 'NA'}
                </span>
              )}
            </div>
          </div>
          {/* Bold Name */}
          <span className="text-gray-800 fw-bold fs-6">
            {user?.personalDetails?.name || ''}
          </span>
        </div>
      );

    case "lifeTimePerformance1":
      return (
        <>
          <span className={`badge ${(user?.lifeTimePerformance || 0) > 0 ? 'badge-light-success' : 'badge-light-danger'} fs-7 fw-bold`}>
            {(user?.lifeTimePerformance || 0).toFixed(2)}
          </span>
          {' kg'}
        </>
      );
    case "avgYearlyCollected1":
      return (
        <>
          <span className={`badge ${(user?.avgYearlyCollected || 0) > 0 ? 'badge-light-success' : 'badge-light-danger'} fs-7 fw-bold`}>
            {(user?.avgYearlyCollected || 0).toFixed(2)}
          </span>
          {' kg'}
        </>
      );
    case "avgMonthlyCollected1":
      return (
        <>
          <span className={`badge ${(user?.avgMonthlyCollected || 0) > 0 ? 'badge-light-success' : 'badge-light-danger'} fs-7 fw-bold`}>
            {(user?.avgMonthlyCollected || 0).toFixed(2)}
          </span>
          {' kg'}
        </>
      );
    case "avgDailyCollected1":
      return (
        <>
          <span className={`badge ${(user?.avgDailyCollected || 0) > 0 ? 'badge-light-success' : 'badge-light-danger'} fs-7 fw-bold`}>
            {(user?.avgDailyCollected || 0).toFixed(2)}
          </span>
          {' kg'}
        </>
      );



    case 'mobile':
    case 'email':
      return user?.personalDetails?.[mapData] || ''
    case 'icon':
    case 'logo':
    case 'paymentProof':
      return (
        <div className='symbol symbol-circle'>
          {user?.[mapData] ? (
            <img
              src={user?.[mapData] || ''}
              alt={user.name}
              onClick={() =>
                lightBoxRef?.current?.open(`${user?.[mapData] || ''}`, itemIdForUpdate)
              }
            />
          ) : (
            ''
          )}
          {user.transactionId && mapData && <ImageLightBox ref={lightBoxRef} />}
        </div>
      )
    case 'categoryIcon':
      return (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            <img
              src={`${user?.orderDetails?.[0]?.categoryIcon || ''}`}
              alt={user?.name}
              className='w-100'
            />
          </div>
        </div>
      )


    case "ProductImgae":
      return (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {user?.productImages?.map((imageObj, index) => (
            <div
              key={index}
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundImage: `url(${imageObj.url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                border: '2px solid #ddd'
              }}
            />
          )) || []}
        </div>
      )



    case "truckTypet":
      return user.truckType
    case "fuelEfficiencyt":
      return user.fuelEfficiency ? user.fuelEfficiency.toFixed(4) : "0.0000"
    case "ch4Emissionst":
      return user.ch4Emissions ? user.ch4Emissions.toFixed(4) : "0.0000"
    case "n2oEmissionst":
      return user.n2oEmissions ? user.n2oEmissions.toFixed(4) : "0.0000"




    case "lbitem":
      return user?.productionItemDetails?.[0]?.itemName
    case "lbQty":
      return user?.productionItemDetails?.[0]?.quantity


    case 'inputQuantity':
      return (user?.inputQuantity || '0') + ' kg'

    case 'processType':
      return (
        <span
          className={`${user?.processType === 'DIVERSION' ? 'badge badge-light-success' : ''} `}
        >
          {(user.processType &&
            (user?.processType === 'DIVERSION' ? 'Recycling' : 'Pre processing')) ||
            ''}
        </span>
      )


    case 'Categoryddp':
      return (
        <span
          className={`${user?.processType === 'DIVERSION' ? 'badge badge-light-success' : ''} `}
        >
          {user.productionItem[0]?.outputMaterialCategoryName || ''}
        </span>
      )
    case 'itemddp':
      return user.productionItem[0]?.outputMaterialName
    case 'outputQty':
      return user.productionItem[0]?.outputQuantity ? Number(user.productionItem[0].outputQuantity).toFixed(2) : '0.00'



    case "newCC":
      const clientLogoDocument1 = user?.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {clientLogoDocument1?.docUrl && (
            <img
              src={clientLogoDocument1.docUrl}
              alt="Client Logo"
              style={{
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '1px solid #ccc',
              }}
            />
          )}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className="text-gray-800 fw-bold fs-6 mb-1"
            >
              {user?.companyDetails?.name}
            </span>
            <span className="text-dark fs-7">
              {user?.address?.country}
            </span>
          </div>
        </div>
      )

    case 'creditbuyerpp':
      const clientLogoDocument = user?.kycDocument?.find(doc => doc.docType === 'CLIENT_LOGO')
      return (
        <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            {clientLogoDocument?.docUrl ? (
              <img
                src={clientLogoDocument.docUrl}
                alt={user?.name}
                className='w-100'
                onClick={() =>
                  lightBoxRef?.current?.open(
                    clientLogoDocument.docUrl,
                    itemIdForUpdate
                  )
                }
              />
            ) : (
              <div className='symbol-label fs-3 bg-light-primary text-primary'>
                {user?.personalDetails?.name?.substring(0, 2).toUpperCase() || 'NA'}
              </div>
            )}
            {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
          </div>
        </div>
      )


    case "statusUi":
      return (
        <span className={`badge badge-light-${user.active ? 'success' : 'danger'} fs-7 fw-bold`}>
          {user.active ? 'Active' : 'Inactive'}
        </span>
      )
    case "hubUserName":
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img className='rounded-circle w-10 h-10 object-fit-cover' src={user?.kycDocument?.find((doc) => doc?.docType === "POF")?.docUrl || ''} alt={user.userName} />
          <span>{user.userName}</span>
        </div>
      )
    case "incentiveBadgeImage":
      return (
        <div>
          <img className='w-10 h-10 object-fit-cover rounded-circle' src={user?.badge?.badgeImageUrl || ''} alt={user.badge?.badgeName || ''} />
        </div>
      )
    case "incentiveBannerImage":
      return (
        <div>
          <img className='w-10 h-10 object-fit-cover rounded-circle' src={user?.imageUrl || ''} alt={user.badge?.badgeName || ''} />
        </div>
      )
    case "incentiveVoluntiers":
      return (
        <div className="flex items-center">
          {user?.facilityStaff?.map((staff, index) => (
            <div
              key={staff?.id || index}
              className="relative group"
              style={{
                marginLeft: index === 0 ? 0 : "-12px",
                zIndex: user?.facilityStaff?.length - index,
              }}
            >
              <img
                src={staff?.profile || ""}
                alt={staff?.name || ""}
                className="w-10 h-10 rounded-full object-cover border-2 border-white"
              />

              <div className="absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 pointer-events-none">
                {staff?.name}
              </div>
            </div>
          ))}
        </div>
      )

    case 'viewHistory':
      return (
        <div
          style={{ cursor: 'pointer' }} onClick={() => setshowImageModal({
            show: true,
            clicked: mapData,
          })}>
          View
        </div>
      )
    case 'incentiveAward':
      return (
        <span className={`badge badge-light-${user?.eligible ? 'success' : 'danger'} fs-7 fw-bold`}>{user?.eligible ? 'Yes' : 'No'}</span>
      )
    case 'incentiveTierLevel':
      return (
        <span>{showIncentiveTiers?.[user?.level] || showIncentiveTiers?.[user?.incentiveLevel] || '-'}</span>
      )
    case 'incentivePeriod':
      return (
        <span>{user?.month} - {user?.year}</span>
      )


    case 'processName':
      return (
        <span className={`badge badge-light-info fs-7 fw-bold`}>{user?.processName || ''}</span>
      )
    case 'year-01':
    case 'year-02':
    case 'year-03':
    case 'year-04':
    case 'year-05':
    case 'year-06':
    case 'year-07':
    case 'year-08':
    case 'year-09':
    case 'year-10':
    case 'year-11':
    case 'year-12':
      const transformedData = {}
      const splitMonth = mapData.split('year-')
      Object.keys(user.monthWiseData).forEach((key) => {
        const month = key.split('-')[1] // Extract the MM part
        transformedData[month] = user.monthWiseData[key]
      })
      return transformedData[splitMonth?.[1]]?.toFixed(2) || '0'


    case 'categoryName':
      return (
        <span className={`badge badge-light-info fs-7 fw-bold`}>
          {(user?.orderDetails || user?.orderDetail)?.[0]?.categoryName || user?.categoryName || ''}
        </span>
      )

    case 'categoryNameCollectOrder':
      return (
        <>
          {user?.orderDetails?.map((item) => <span className={`badge badge-light-info fs-7 fw-bold`}>{item?.categoryName}</span>)}
        </>

      )
    case 'typen':
      return (
        <span className={`badge badge-light-info fs-7 fw-bold`}>
          {user?.itemType === 'DIVERSION' ? 'Finished product' :
            user?.itemType === 'NON_DIVERSION' ? 'Raw material' :
              user?.itemType}
        </span>
      )
    case 'categoryName1':
      return (
        <span>
          {(user?.orderDetails || user?.orderDetail)?.[0]?.categoryName || user?.categoryName || ''}
        </span>
      )


    // case 'targetValue':
    //   return (
    //     user?.tests?.map((x) =>
    //       x?.parameters.map((y) => (
    //         <span className={`badge badge-light-success fs-7 fw-bold`}>
    //           {y?.[mapData]}
    //           <br />
    //         </span>
    //       ))
    //     ) || '-'
    //   )


    case 'targetValue':
      return (
        user?.tests?.map((x) =>
          x?.parameters.map((y) => (
            <span
              className={`badge badge-light-success fs-7 fw-bold`}
              style={{
                display: 'block',
                marginBottom: '5px',
                width: 'fit-content'
              }}
            >
              {y?.[mapData]}
              <br />
            </span>
          ))
        ) || '-'
      )



    case 'remark':
      return user?.orderDetails?.[0]?.items
        ?.map((x) => x?.itemName || '')
        .join(', ')

    case "enimages":
      return (
        <div className="flex flex-wrap gap-3">
          {user.images?.map((image, index) => (
            <div key={index} className="flex flex-col items-center">
              <img
                src={image.url}
                alt={image.description}
                className="w-16 h-16 rounded-full object-cover border-2 border-gray-200  transition-shadow duration-200"
              />
            </div>
          ))}
        </div>
      );



    // case 'commitmentTypett':
    //   if (user.commitmentType === "COLLECT") {
    //     return (
    //       <span style={{
    //         color: '#7239ea',
    //         backgroundColor: '#d0bdf9',
    //         borderRadius: '8px',
    //         padding: '4px 8px',
    //         fontWeight: 'bold',
    //         fontSize: '12px'
    //       }}>
    //         Collection
    //       </span>
    //     );
    //   } else if (user.commitmentType === "RECYCLE") {
    //     return (
    //       <span style={{
    //         color: '#17c653',
    //         backgroundColor: '#a4eebd',
    //         borderRadius: '8px',
    //         padding: '4px 8px',
    //         fontWeight: 'bold',
    //         fontSize: '12px'
    //       }}>
    //         Recycling
    //       </span>
    //     );
    //   }
    //   return user.commitmentType;



    case 'commitmentTypett':
      if (user.commitmentType === "COLLECT") {
        return (
          <span className={`badge badge-light-info fs-7 fw-bold`}>
            Collection
          </span>
        );
      } else if (user.commitmentType === "RECYCLE") {
        return (
          <span style={{
            color: '#17c653',
            backgroundColor: '#dfffea',
            borderRadius: '8px',
            padding: '4px 8px',
            fontWeight: 'bold',
            fontSize: '12px'
          }}>
            Recycling
          </span>
        );
      }
      return user.commitmentType;



    case "sponsorNametyty":
      return user.sponsorName


    // case 'quantityDeposit_remark':
    //   return user?.orderDetails?.[0]?.items
    //     ?.map((x) => (mapData === 'remark' ? x?.itemName : x.quantity + ' kg') || '')
    //     .join(', ')

    // case 'quantityDeposit_remark':
    //   return user?.orderDetails?.[0]?.items
    //     ?.reduce((sum, x) => sum + (x.quantity || 0), 0)

    case 'quantityDeposit_remark':
      return <>

        {user?.orderDetails?.map((item, ind) => {
          return (
            <span key={ind + 1 + ''}>
              {item?.items
                ?.reduce((sum, x) => sum + (x.quantity || 0), 0)
                ?.toFixed(2)}
              <br />
            </span>)
        })}
      </>

    case 'testName':
      return user?.tests?.map((x) => x?.testName || '').join(', ') || '-'
    case 'parameter':
    // case 'targetValue':
    case 'minimum':
    case 'maximum':
    case 'standard':
      // return user?.tests?.map((x) => x?.parameters.map((y) => y?.[mapData]) || '').join(', ') || '-'
      return (
        user?.tests?.map((x) =>
          x?.parameters.map((y) => (
            <>
              {y?.[mapData]}
              <br />
            </>
          ))
        ) || '-'
      )
    case 'pricesss':
      return user.price + '' || ''
    case 'hhPrice':
      return user.customerPrice + '' || ''
    case 'benefitName':
      return ((user?.customerPrice / user?.price) * 100).toFixed(2) + ' %'
    case 'price':
      return user?.orderDetails?.[0]?.items?.map((x) => x[mapData] || '').join(', ') || '-'
    case 'quantityDeposit':
      const totalQuantity =
        user?.orderDetails?.[0]?.items?.reduce((acc, curr) => {
          return acc + curr.quantity
        }, 0) || 0
      return <span className='text-primary fs-7 fw-bold'>{totalQuantity?.toFixed(2) + ' kg'}</span>
    // case 'pickup_quantity':
    // case 'pickup_quantity_item':
    //   return (user?.orderDetails || user?.orderDetail)?.[0].items?.map((x: any, ind: number) => (
    //     // <div className='text-primary fs-7 fw-bold' key={ind + 1 + ''}>
    //     <div className='text-gray-800 fs-7' key={ind + 1 + ''}>
    //       {mapData === 'pickup_quantity_item' ? x.itemName : x.quantity?.toFixed(2)}{' '}
    //       {mapData === 'pickup_quantity' ? 'kg' : ''}
    //     </div>
    //   ))

    case 'pickup_quantity_item':
      const orderDetail = (user?.orderDetails || user?.orderDetail)?.[0];
      if (!orderDetail?.items) return '-';

      return orderDetail.items.map((x: any, ind: number) => (
        <div className='text-gray-800 fs-7' key={ind + 1 + ''}>
          {mapData === 'pickup_quantity_item' ? x.itemName : x.quantity?.toFixed(2)}{' '}
          {mapData === 'pickup_quantity' ? 'kg' : ''}
        </div>
      ))

    case 'pickup_quantity':
      const pickupTotalQuantity = (user?.orderDetails || user?.orderDetail)?.[0]?.items?.reduce(
        (sum: number, x: any) => sum + (Number(x?.quantity) || 0),
        0
      ) || 0;

      const transportationLossQuantity = (user?.transportationLoss)?.[0]?.items?.reduce(
        (sum: number, x: any) => sum + (Number(x?.quantity) || 0),
        0
      ) || 0;

      return (
        <div className='text-gray-800 fs-7'>
          {(pickupTotalQuantity - transportationLossQuantity).toFixed(2)}
        </div>
      );



    case "totalAmountI":
      return Number(parseFloat(user.totalAmount || 0).toFixed(2))





    case "materialHub":
      return Array.isArray(user.linkedPickupPointName)
        ? user.linkedPickupPointName.join(", ")
        : user.linkedPickupPointName


    case "packageLogo":
      return (
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #e0e0e0',
          backgroundColor: '#f5f5f5'
        }}>
          <img
            src={user.packageLogo}
            alt='package logo'
            onError={(e) => {
              e.currentTarget.src = '/icons8-error-64.png'
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>
      )


    case "packageLogocm":
      return (
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid #e0e0e0',
          backgroundColor: '#f5f5f5'
        }}>
          <img
            src={user?.packageInfo?.packageLogo}
            alt='package logo'
            onError={(e) => {
              e.currentTarget.src = '/icons8-error-64.png'
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </div>
      )

    // case "Householdcm":
    //   return user?.packageInfo?.householdConnected
    case "Householdcm":
      return user?.actualCustomerCount
        ? (
          <span style={{ backgroundColor: '#F8F5FF', color: '#7c3aed', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
            {/* {user?.packageInfo?.householdConnected} / {user.actualCustomerCount} */}
            {user.actualCustomerCount} / {user?.packageInfo?.householdConnected}
          </span>
        )
        : (
          <span style={{ backgroundColor: '#F8F5FF', color: '#7c3aed', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
            {user?.packageInfo?.householdConnected}
          </span>
        )

    case "plasticPreventedcm":
      return user?.actualQty
        ? (
          <span style={{ backgroundColor: '#F8F5FF', color: '#7c3aed', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
            {/* {user?.packageInfo?.plasticPrevented} / {user.actualQty} */}
            {user.actualQty} / {user?.packageInfo?.plasticPrevented}

          </span>
        )
        : (
          <span style={{ backgroundColor: '#F8F5FF', color: '#7c3aed', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
            {user?.packageInfo?.plasticPrevented}
          </span>
        )


    case "appUsers":
      return Array.isArray(user.facilityStaff)
        ? user.facilityStaff.map((staff, index) => (
          <div key={staff.id}>{staff.name}</div>
        ))
        : user.facilityStaff

    // case 'bussinessPermit':
    //   return (
    //     <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
    //       <div className='symbol-label'>
    //         {/*  <img
    //           alt={user.name}
    //           className='w-100'
    //           src={`${user?.kycDocument?.[0]?.docUrl || ''}`}
    //         /> */}
    //         <img
    //           src={`${user?.kycDocument?.[0]?.docUrl || ''}`}
    //           alt={user.name}
    //           className='w-100'
    //           onClick={() =>
    //             lightBoxRef?.current?.open(
    //               `${user?.kycDocument?.[0]?.docUrl || ''}`,
    //               itemIdForUpdate
    //             )
    //           }
    //         />
    //         {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
    //       </div>
    //     </div>
    //   )




    // case 'bussinessPermit':
    //   return (
    //     <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
    //       <div className='symbol-label'>
    //         {user?.kycDocument?.[0]?.docUrl ? (
    //           <img
    //             src={user.kycDocument[0].docUrl}
    //             alt={user.name}
    //             className='w-100'
    //             onClick={() =>
    //               lightBoxRef?.current?.open(
    //                 user.kycDocument[0].docUrl,
    //                 itemIdForUpdate
    //               )
    //             }
    //           />
    //         ) : (
    //           <div className='symbol-label fs-3 bg-light-primary text-primary'>
    //             {user?.personalDetails?.name?.substring(0, 2).toUpperCase() || 'NA'}
    //           </div>
    //         )}
    //         {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
    //       </div>
    //     </div>
    //   )




    // case 'bussinessPermit':
    //   // Find the POF document in the kycDocument array
    //   const pofDocument = user?.kycDocument?.find(doc => doc.docType === 'POF');

    //   return (
    //     <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
    //       <div className='symbol-label'>
    //         {pofDocument?.docUrl ? (
    //           <img
    //             src={pofDocument.docUrl}
    //             alt={user?.name}
    //             className='w-100'
    //             onClick={() =>
    //               lightBoxRef?.current?.open(
    //                 pofDocument.docUrl,
    //                 itemIdForUpdate
    //               )
    //             }
    //           />
    //         ) : (
    //           <div className='symbol-label fs-3 bg-light-primary text-primary'>
    //             {user?.personalDetails?.name?.substring(0, 2).toUpperCase() || 'NA'}
    //           </div>
    //         )}
    //         {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
    //       </div>
    //     </div>
    //   )

    case 'bussinessPermit':
      // Find the POF document in the kycDocument array
      const pofDocument3 = user?.kycDocument?.find(doc => doc.docType === 'POF');

      return (
        <div className="d-flex align-items-center">
          {/* Profile Image */}
          <div className="symbol symbol-40px symbol-circle me-3">
            <div className="symbol-label">
              {pofDocument3?.docUrl ? (
                <img
                  src={pofDocument3.docUrl}
                  alt={user?.name}
                  className="w-100 h-100 rounded-circle object-cover"
                  onClick={() =>
                    lightBoxRef?.current?.open(pofDocument3.docUrl, itemIdForUpdate)
                  }
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <span className="symbol-label bg-light-primary text-primary fs-7 fw-bold">
                  {user?.personalDetails?.name
                    ?.trim()
                    .split(' ')
                    .map(word => word.charAt(0))
                    .join('')
                    .toUpperCase()
                    .slice(0, 2) || 'N/A'}
                </span>
              )}
            </div>
          </div>

          {/* Name and Email */}
          <div className="d-flex flex-column">
            <span
              className="text-gray-800 fw-bold fs-6 mb-1"
              style={{ whiteSpace: 'nowrap' }}
            >
              {user.personalDetails?.name?.trim() || 'N/A'}
            </span>
            <span className="text-dark fs-7">
              {user.personalDetails?.email || 'N/A'}
            </span>
          </div>

          {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
        </div>
      );





    // case 'bussinessPermitI':
    //   // Find the POF document in the kycDocument array
    //   const pofDocument1 = user?.kycDocument?.find(doc => doc.docType === 'POI');

    //   return (
    //     <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
    //       <div className='symbol-label'>
    //         {pofDocument1?.docUrl ? (
    //           <img
    //             src={pofDocument1.docUrl}
    //             alt={user?.name}
    //             className='w-100'
    //             onClick={() =>
    //               lightBoxRef?.current?.open(
    //                 pofDocument1.docUrl,
    //                 itemIdForUpdate
    //               )
    //             }
    //           />
    //         ) : (
    //           <div className='symbol-label fs-3 bg-light-primary text-primary'>
    //             {user?.personalDetails?.name?.substring(0, 2).toUpperCase() || 'NA'}
    //           </div>
    //         )}
    //         {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
    //       </div>
    //     </div>
    //   )

    case 'bussinessPermitI':
      // Find the POF document in the kycDocument array
      const pofDocument1 = user?.kycDocument?.find(doc => doc.docType === 'POI');
      return (
        <div className="d-flex align-items-center">
          {/* Profile Image */}
          <div className="symbol symbol-40px symbol-circle me-3">
            <div className="symbol-label">
              {pofDocument1?.docUrl ? (
                <img
                  src={pofDocument1.docUrl}
                  alt={user?.name}
                  className="w-100 h-100 rounded-circle object-cover"
                  onClick={() =>
                    lightBoxRef?.current?.open(
                      pofDocument1.docUrl,
                      itemIdForUpdate
                    )
                  }
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <span className="symbol-label bg-light-primary text-primary fs-7 fw-bold">
                  {user?.personalDetails?.name
                    ?.trim()
                    .split(' ')
                    .map(word => word.charAt(0))
                    .join('')
                    .toUpperCase()
                    .slice(0, 2) || 'N/A'}
                </span>
              )}
            </div>
          </div>
          {/* Name and Email */}
          <div className="d-flex flex-column">
            <span
              className="text-gray-800 fw-bold fs-6 mb-1"
              style={{ whiteSpace: 'nowrap' }}
            >
              {user.personalDetails?.name?.trim() || 'N/A'}
            </span>
            <span className="text-dark fs-7">
              {user.personalDetails?.mobile || 'N/A'}
            </span>
          </div>
          {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
        </div>
      );

    // case "Addressnn":
    //   return user?.address?.street
    case "Addressnn":
      return user?.address?.street?.slice(0, 25) + (user?.address?.street?.length > 25 ? '...' : '')

    case "totalDepositedQuantitynnn":
      return (
        <>
          <span className={`badge ${user.totalDepositedQuantity === 0 ? 'badge-light-danger' : 'badge-light-success'} fs-7 fw-bold`}>
            {user.totalDepositedQuantity}
          </span>
          {' kg'}
        </>
      )

    case "statusUm":
      return user.active ? (
        <span className='badge badge-light-success fw-bold'>
          ACTIVE
        </span>
      ) : (
        <span className='badge fw-bold' style={{ backgroundColor: '#fff8dd', color: '#fbd124' }}>
          INACTIVE
        </span>
      )
    case "status1":
      return user.active ? (
        <span className='badge badge-light-success fw-bold'>
          ACTIVE
        </span>
      ) : (
        <span className='badge fw-bold' style={{ backgroundColor: '#fff8dd', color: '#fbd124' }}>
          INACTIVE
        </span>
      )
    case "status2":
      return user.active ? (
        <span className='badge badge-light-success fw-bold'>
          ACTIVE
        </span>
      ) : (
        <span className='badge fw-bold' style={{ backgroundColor: '#fff8dd', color: '#fbd124' }}>
          INACTIVE
        </span>
      )


    case "cerImg":
      return user.certifications?.[0]?.logo ? (
        <img
          src={user.certifications[0].logo}
          alt="Certification"
          style={{
            width: '40px',
            height: '40px',
            objectFit: 'cover',
            borderRadius: '50%',
            cursor: 'pointer'
          }}
          onClick={() => window.open(user.certifications[0].logo, '_blank')}
        />
      ) : '-'


    case "scannedImageUrl":
      return user?.weightScale?.scannedImageUrl ? (
        <img
          src={user.weightScale.scannedImageUrl}
          alt="Scanned"
          style={{
            width: '40px',
            height: '40px',
            objectFit: 'cover',
            borderRadius: '50%',
            cursor: 'pointer'
          }}
          onClick={() => window.open(user.weightScale.scannedImageUrl, '_blank')}
        />
      ) : '-'


    case 'sponsorLogo':
      return (
        <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            {user?.sponsorLogo ? (
              <img
                src={user.sponsorLogo}
                alt={user?.name}
                className='w-100'
                onClick={() =>
                  lightBoxRef?.current?.open(
                    user.sponsorLogo,
                    itemIdForUpdate
                  )
                }
              />
            ) : (
              <div className='symbol-label fs-3 bg-light-primary text-primary'>
                {user?.personalDetails?.name?.substring(0, 2).toUpperCase() || 'NA'}
              </div>
            )}
            {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
          </div>
        </div>
      )


    case 'POE_null':
    case 'POI_null':
      const images = user?.kycDocumentList?.[mapData === 'POE_null' ? 0 : 1]?.docUrl || ''
      return (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            <img
              src={images}
              alt={user?.name}
              className='w-100'
              onClick={() => lightBoxRef?.current?.open(images, itemIdForUpdate)}
            />
            {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
          </div>
        </div>
      )


    // case "CertificateTry":
    //   return (
    //     <div style={{ display: 'flex', gap: '10px' }}>
    //       {user.isccEuCertificate && (
    //         <img
    //           src="/logo2.jpg"
    //           alt="Certificate"
    //           style={{
    //             width: '50px',
    //             height: '50px',
    //             borderRadius: '50%',
    //             objectFit: 'cover'
    //           }}
    //         />
    //       )}
    //       {user.riverNearby && (
    //         <img
    //           src="/logo.png"
    //           alt="River Nearby"
    //           style={{
    //             width: '50px',
    //             height: '50px',
    //             borderRadius: '50%',
    //             objectFit: 'cover'
    //           }}
    //         />
    //       )}
    //     </div>
    //   );


    case "CertificateTry":
      return (
        <div
          style={{ display: 'flex', gap: '10px', cursor: 'pointer' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            });
          }}
        >
          {user.isccEuCertificate && (
            <img
              src="/logo2.jpg"
              alt="Certificate"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover'
              }}
            />
          )}
          {user.riverNearby && (
            <img
              src="/logo.png"
              alt="River Nearby"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                objectFit: 'cover'
              }}
            />
          )}
        </div>
      );


    case "EEC":
      return user?.isccEu?.eec?.value ?? 'N/A';
    case "EL":
      return user?.isccEu?.el?.value ?? 'N/A';
    case "ESCA":
      return user?.isccEu?.esca?.value ?? 'N/A';
    case "Methane":
      return user?.isccEu?.methaneCredit?.value ?? 'N/A';
    case "LHV":
      return user?.isccEu?.lhv ?? 'N/A';
    case "Cat":
      return getCategoryName(user.categoryId);

    case 'KYC':
      console.log('=== KYC CASE HIT ===');
      console.log('user.kycDocument:', user?.kycDocument);

      const hasValidDocuments = user?.kycDocument?.some(doc =>
        (doc.docUrl && doc.docUrl.trim() !== '') ||
        (doc.docNumber && doc.docNumber.trim() !== '')
      );
      console.log('Has valid documents:', hasValidDocuments);

      if (!hasValidDocuments) {
        console.log('No valid documents found');
        return (
          <div style={{
            cursor: 'not-allowed',
            opacity: 0.5,
            color: '#999'
          }}>
            Click to view
          </div>
        );
      }

      console.log('Valid documents found, showing click to view');
      return (
        <div
          onClick={() =>
            setshowImageModal({
              show: true,
              clicked: mapData,
            })
          }
          style={{ cursor: 'pointer' }}
        >
          Click to view
        </div>
      )

    case 'actualCollectionDate':
      return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#2e7d32'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
              <line x1='16' y1='2' x2='16' y2='6' />
              <line x1='8' y1='2' x2='8' y2='6' />
              <line x1='3' y1='10' x2='21' y2='10' />
            </svg>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e', whiteSpace: 'nowrap' }}>
              {user.actualCollectionDate ? user.actualCollectionDate.substring(0, 10) : ''}
            </span>
            <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>-</span>
          </div>
        </div>
      )
    case 'actualSupplyDate':
      return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#2e7d32'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
              <line x1='16' y1='2' x2='16' y2='6' />
              <line x1='8' y1='2' x2='8' y2='6' />
              <line x1='3' y1='10' x2='21' y2='10' />
            </svg>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e', whiteSpace: 'nowrap' }}>
              {user.actualSupplyDate ? user.actualSupplyDate.substring(0, 10) : ''}
            </span>
            <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>-</span>
          </div>
        </div>
      )
    case 'actualProcessDate':
      return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#2e7d32'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
              <line x1='16' y1='2' x2='16' y2='6' />
              <line x1='8' y1='2' x2='8' y2='6' />
              <line x1='3' y1='10' x2='21' y2='10' />
            </svg>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e', whiteSpace: 'nowrap' }}>
              {user.actualProcessDate ? user.actualProcessDate.substring(0, 10) : ''}
            </span>
            <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>-</span>
          </div>
        </div>
      )
    case 'actualProcessDatelb':
      return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#2e7d32'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
              <line x1='16' y1='2' x2='16' y2='6' />
              <line x1='8' y1='2' x2='8' y2='6' />
              <line x1='3' y1='10' x2='21' y2='10' />
            </svg>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e', whiteSpace: 'nowrap' }}>
              {new Date(user?.createdAt).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              })}
            </span>
            <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>-</span>
          </div>
        </div>
      )
    case 'createdAt':
    case 'supplyDate':
    case 'productionDate':
      return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#2e7d32'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
              <line x1='16' y1='2' x2='16' y2='6' />
              <line x1='8' y1='2' x2='8' y2='6' />
              <line x1='3' y1='10' x2='21' y2='10' />
            </svg>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e', whiteSpace: 'nowrap' }}>
              {user?.[mapData] ? new Date(+user?.[mapData] || new Date()).toLocaleDateString() : '-'}
            </span>
            <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>-</span>
          </div>
        </div>
      )
    case 'date': {
      const rawDate = user?.date ? new Date(+user.date) : null
      if (!rawDate || isNaN(rawDate.getTime())) return '-'
      const dateStr = rawDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
      const timeStr = rawDate.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <div
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              backgroundColor: '#e8f5e9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#2e7d32'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='4' width='18' height='18' rx='2' ry='2' />
              <line x1='16' y1='2' x2='16' y2='6' />
              <line x1='8' y1='2' x2='8' y2='6' />
              <line x1='3' y1='10' x2='21' y2='10' />
            </svg>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e', whiteSpace: 'nowrap' }}>
              {dateStr}
            </span>
            <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>{timeStr}</span>
          </div>
        </div>
      )
    }
    case 'transactionId': {
      const txId = user?.transactionId || user?.orderId || '-'
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e' }}>{txId}</span>
          <span
            title='Copy'
            style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0 }}
            onClick={(e) => {
              e.stopPropagation()
              navigator.clipboard?.writeText(txId)
              const el = e.currentTarget as HTMLElement
              el.style.color = '#22c55e'
              setTimeout(() => { el.style.color = '#aaa' }, 1200)
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='9' y='9' width='13' height='13' rx='2' ry='2' />
              <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' />
            </svg>
          </span>
        </div>
      )
    }
    case 'materialInwardBatchId': {

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e' }}>{user?.id}</span>
          <span
            title='Copy'
            style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0 }}
            onClick={(e) => {
              e.stopPropagation()
              navigator.clipboard?.writeText(user?.id)
              const el = e.currentTarget as HTMLElement
              el.style.color = '#22c55e'
              setTimeout(() => { el.style.color = '#aaa' }, 1200)
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='9' y='9' width='13' height='13' rx='2' ry='2' />
              <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' />
            </svg>
          </span>
        </div>
      )
    }
    case 'productionId':
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontWeight: '600', fontSize: '13px', color: '#1a1a2e' }}>{user?.productionId}</span>
          <span
            title='Copy'
            style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0 }}
            onClick={(e) => {
              e.stopPropagation()
              navigator.clipboard?.writeText(user?.productionId)
              const el = e.currentTarget as HTMLElement
              el.style.color = '#22c55e'
              setTimeout(() => { el.style.color = '#aaa' }, 1200)
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='9' y='9' width='13' height='13' rx='2' ry='2' />
              <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' />
            </svg>
          </span>
        </div>
      )

    case 'pickupPointName': {
      const hubName = user?.pickupPointName || user?.fromPickupPointName || user?.centreInfo?.name
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              backgroundColor: '#ede9fe',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='17'
              height='17'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#7c3aed'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <path d='M3 21h18' />
              <rect x='9' y='5' width='6' height='16' rx='1' />
              <path d='M10 5l2-2 2 2' />
              <rect x='4' y='9' width='4' height='12' rx='1' />
              <rect x='16' y='9' width='4' height='12' rx='1' />
              <path d='M11 21v-4h2v4' />
              <path d='M11 9h2' />
              <path d='M11 13h2' />
            </svg>
          </div>
          <span style={{ fontWeight: '500', fontSize: '13px', color: '#1a1a2e' }}>{hubName}</span>
        </div>
      )
    }

    case "actualCollectionDateMI":
      return user.actualCollectionDate ? user.actualCollectionDate.substring(0, 10) : '';
    case "actualProcessDate1":
      return user?.actualProcessDate ? user.actualProcessDate.substring(0, 10) : '';
    case "actualSupplyDate1":
      return user?.actualSupplyDate ? user.actualSupplyDate.substring(0, 10) : '';

    case "actualProcessDateR":
      return user?.actualProcessDate ? user.actualProcessDate.substring(0, 10) : '';

    case 'proofEstablishment':
    case 'proofOfIdentity':
    case 'proofOfFacility':
    case 'POF':
    case 'POI':
    case 'POE':
    case 'CLIENT_LOGO':
    case 'personalImage':
    case 'EXN_AGGREMENT':
    case 'SEC_DTI':
      const image = user?.kycDocument?.filter((x) => x?.docType === mapData)?.[0]?.docUrl || ''
      return (
        <div className='symbol symbol-circle swymbol-50px overflow-hidden me-3'>
          <div className='symbol-label'>
            <img
              src={image}
              alt={user?.name}
              className='w-100'
              onClick={() => lightBoxRef?.current?.open(image, itemIdForUpdate)}
            />
            {user.id && mapData && <ImageLightBox ref={lightBoxRef} />}
          </div>
        </div>
      )
    case 'pickup_address':
      return clipText(generateAddress(user.pickupInfo?.address))
    case 'address':
      // return generateAddress(user.address || user.pickupInfo?.address)
      const addressConcat = generateAddress(
        user.address || user.pickupInfo?.address || user.dropOffPointInfo?.address
      )
      return (
        <div data-bs-toggle='tooltip' title={addressConcat}>
          {clipText(addressConcat, 30)}
        </div>
      )
    // case 'wastage':
    //   return (
    //     <span className='badge badge-light-danger fs-7 fw-bold'>
    //       {user?.wastage?.toFixed(2)} kg
    //     </span>
    //   )
    case 'wastage':
      return <span className='badge badge-light-danger fs-7 fw-bold'>
        {Number(user?.wastage?.toFixed(2)) || 0}
      </span>
    case 'teamSize':
      return <span className=''>{user?.teamSize}</span>
    case 'manager':
      return user?.companyDetails?.name
    case 'geoLocation':
      // return user.address.latitute + ' , ' + user.address.longitute
      return (
        <>
          <div>{user?.address?.latitute}</div>
          <div>{user?.address?.longitute}</div>
        </>
      )
    case 'pickupCompletedAt':
      return (
        (user?.pickupInfo?.pickupCompletedAt &&
          new Date(+user?.pickupInfo?.pickupCompletedAt || new Date()).toLocaleDateString()) ||
        ''
      )
    case 'collectionDate':
    case 'completedAt':
    case 'date':
    case 'approvedAt':
      return new Date(+user?.[mapData] || new Date()).toLocaleDateString()

    case 'pickupDate':
      return new Date(+user?.pickupInfo?.pickupDate || new Date()).toLocaleDateString()

    // case 'customerType':
    //   return (
    //     <span
    //       className={`badge badge-light-${user?.[mapData] === 'INDIVIDUAL' ? 'success' : 'primary'
    //         } fs-7 fw-bold`}
    //     >
    //       {user?.[mapData]}
    //     </span>
    //   )


    // case 'customerType':
    //   const customerTypeMapping = {
    //     'HOUSEHOLD': 'Household',
    //     'WASTE_PICKER': 'Farms / Plantations',
    //     'JUNK_SHOP': 'Agro Mills',
    //     'MRF': 'Livestock Farms',
    //     'FACTORY': 'Restaurants, Public Containers',
    //     'COMMERCIAL_ESTABLISHMENT': 'Oil Mills/ Industrial',
    //     'CITY_GOVERNMENT': 'Municipal Collection Points',
    //     'EVENT': 'Dedicated Energy Crop Plantations',
    //     'INTERCEPTOR': 'Forest Management Units, Sawmills'
    //   };
    //   const displayName = customerTypeMapping[user?.customerType] || user?.customerType;

    //   return (
    //     <span
    //       className={`badge badge-light-${user?.customerType === 'HOUSEHOLD' ? 'success' : 'primary'} fs-7 fw-bold`}
    //     >
    //       {displayName}
    //     </span>
    //   )






    // case 'customerType':
    //   return (() => {
    //     const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    //     const segmentType = authData?.data?.segmentType;

    //     if (segmentType === "BIOFUEL") {
    //       const customerTypeMapping = {
    //         'HOUSEHOLD': 'Household',
    //         'WASTE_PICKER': 'Farms / Plantations',
    //         'JUNK_SHOP': 'Agro Mills',
    //         'MRF': 'Livestock Farms',
    //         'FACTORY': 'Restaurants, Public Containers',
    //         'COMMERCIAL_ESTABLISHMENT': 'Oil Mills/ Industrial',
    //         'CITY_GOVERNMENT': 'Municipal Collection Points',
    //         'EVENT': 'Dedicated Energy Crop Plantations',
    //         'INTERCEPTOR': 'Forest Management Units, Sawmills'
    //       };
    //       const displayName = customerTypeMapping[user?.customerType] || user?.customerType;
    //       return (
    //         <span
    //           className={`badge badge-light-${user?.customerType === 'HOUSEHOLD' ? 'success' : 'primary'} fs-7 fw-bold`}
    //         >
    //           {displayName}
    //         </span>
    //       );
    //     } else {
    //       return (
    //         <span
    //           className={`badge badge-light-${user?.[mapData] === 'INDIVIDUAL' ? 'success' : 'primary'} fs-7 fw-bold`}
    //         >
    //           {user?.[mapData]}
    //         </span>
    //       );
    //     }
    //   })();

    // case 'customerType':
    //   return (() => {
    //     const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    //     const segmentType = authData?.data?.segmentType;
    //     if (segmentType === "BIOFUEL") {
    //       const customerTypeMapping = {
    //         'HOUSEHOLD': 'Household',
    //         'WASTE_PICKER': 'Farms / Plantations',
    //         'JUNK_SHOP': 'Agro Mills',
    //         'MRF': 'Livestock Farms',
    //         'FACTORY': 'Restaurants, Public Containers',
    //         'COMMERCIAL_ESTABLISHMENT': 'Oil Mills/ Industrial',
    //         'CITY_GOVERNMENT': 'Municipal Collection Points',
    //         'EVENT': 'Dedicated Energy Crop Plantations',
    //         'INTERCEPTOR': 'Forest Management Units, Sawmills'
    //       };
    //       const displayName = customerTypeMapping[user?.customerType] || user?.customerType;
    //       return (
    //         <span className='badge badge-light-info fs-7 fw-bold'>
    //           {displayName}
    //         </span>
    //       );
    //     } else {
    //       return (
    //         <span className='badge badge-light-info fs-7 fw-bold'>
    //           {user?.[mapData]}
    //         </span>
    //       );
    //     }
    //   })();





    // case 'customerType':
    //   return (() => {
    //     const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
    //     const segmentType = authData?.data?.segmentType;

    //     if (segmentType === "BIOFUEL") {
    //       const customerTypeMapping = {
    //         'HOUSEHOLD': 'Household',
    //         'WASTE_PICKER': 'Farms / Plantations',
    //         'JUNK_SHOP': 'Agro Mills',
    //         'MRF': 'Livestock Farms',
    //         'FACTORY': 'Restaurants, Public Containers',
    //         'COMMERCIAL_ESTABLISHMENT': 'Oil Mills/ Industrial',
    //         'CITY_GOVERNMENT': 'Municipal Collection Points',
    //         'EVENT': 'Dedicated Energy Crop Plantations',
    //         'INTERCEPTOR': 'Forest Management Units, Sawmills'
    //       };
    //       const displayName = customerTypeMapping[user?.customerType] || user?.customerType;
    //       return (
    //         <span className='badge badge-light-info fs-7 fw-bold'>
    //           {displayName}
    //         </span>
    //       );
    //     } else {
    //       // Default mapping for non-BIOFUEL segments
    //       const defaultCustomerTypeMapping = {
    //         'WASTE_PICKER': 'Waste Picker',
    //         'HOUSEHOLD': 'Household',
    //         'JUNK_SHOP': 'Waste Bank/Junk Shop',
    //         'MRF': 'MRF',
    //         'FACTORY': 'Factory',
    //         'COMMERCIAL_ESTABLISHMENT': 'School/ Malls/ Office',
    //         'CITY_GOVERNMENT': 'Sanitary Landfill',
    //         'EVENT': 'Event',
    //         'INTERCEPTOR': 'Trashboom'
    //       };
    //       const displayName = defaultCustomerTypeMapping[user?.customerType] || user?.customerType;
    //       return (
    //         <span className='badge badge-light-info fs-7 fw-bold'>
    //           {displayName}
    //         </span>
    //       );
    //     }
    //   })();

    case "customerType":
      return <span className="badge badge-light-info fs-7 fw-bold">
        {user?.customerTypeDisplayName}
      </span>

    case "Imagedp":
      return (
        <div className="symbol symbol-40px symbol-circle">
          <div className="symbol-label">
            {user?.personalDetails?.profileImage ? (
              <img
                src={user?.personalDetails?.profileImage}
                alt="Profile"
                className="w-100 h-100 rounded-circle object-cover"
              />
            ) : (
              <span className="symbol-label bg-light-primary text-primary fs-7 fw-bold">
                {user?.personalDetails?.name
                  ?.split(' ')
                  .map(word => word.charAt(0))
                  .join('')
                  .toUpperCase()
                  .slice(0, 2) || 'N/A'}
              </span>
            )}
          </div>
        </div>
      );


    case "SocialIcons":
      const socialLinks = user?.social?.[0] || {};

      return (
        <div className="d-flex gap-2">
          {socialLinks.website && (
            <img
              src="/website.jpg"
              alt="Website"
              className="w-20px h-20px"
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(socialLinks.website, '_blank')}
            />
          )}
          {socialLinks.linkedIn && (
            <img
              src="/linkedin.png"
              alt="LinkedIn"
              className="w-20px h-20px"
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(socialLinks.linkedIn, '_blank')}
            />
          )}
          {socialLinks.twitter && (
            <img
              src="/twitter.png"
              alt="Twitter"
              className="w-20px h-20px"
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(socialLinks.twitter, '_blank')}
            />
          )}
          {socialLinks.facebook && (
            <img
              src="/facebook.png"
              alt="Facebook"
              className="w-20px h-20px"
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(socialLinks.facebook, '_blank')}
            />
          )}
          {socialLinks.ytVideo && (
            <img
              src="/youtube.png"
              alt="YouTube"
              className="w-20px h-20px"
              style={{ cursor: 'pointer' }}
              onClick={() => window.open(socialLinks.ytVideo, '_blank')}
            />
          )}
        </div>
      )


    case "customerTypeWc":

      return <span className={`badge badge-light-warning fs-7 fw-bold`}>
        {user.customerType}
      </span>



    case 'paymentMode':
      return (
        <span
          className={`badge badge-light-${user?.[mapData] === 'CASH'
            ? 'info'
            : user?.[mapData] === 'WALLET'
              ? 'primary'
              : 'success'
            } fs-7 fw-bold`}
        >
          {user?.[mapData] || user?.personalDetails?.[mapData]}
        </span>
      )
    case 'street':
      return clipText(user?.address?.street)
    // case 'issuedOn':
    // case 'issueOn':
    //   return user?.[mapData] ? (
    //     <span
    //       className={`badge badge-light-${mapData !== 'issuedOn' ? 'danger' : 'success'
    //         } fs-7 fw-bold`}
    //     >
    //       {new Date(user?.[mapData] || new Date()).toLocaleDateString()}
    //     </span>
    //   ) : (
    //     '-'
    //   )case 'issuedOn':
    case 'issuedOn':
    case 'issueOn':
      return user?.[mapData] ? (
        <span className='fs-7'>
          {new Date(user?.[mapData] || new Date()).toLocaleDateString()}
        </span>
      ) : (
        '-'
      )
    // case 'validTill':
    //   return user?.[mapData] ? (
    //     <span
    //       className={`badge badge-light-${mapData !== 'issuedOn' ? 'danger' : 'success'
    //         } fs-7 fw-bold`}
    //     >
    //       {new Date(user?.[mapData] || new Date()).toLocaleDateString()}
    //     </span>
    //   ) : (
    //     '-'
    //   )

    case 'validTill':
      if (!user?.[mapData]) return '-'

      const today = new Date()
      const dueDate = new Date(user?.[mapData])
      const timeDiff = dueDate.getTime() - today.getTime()
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

      let badgeClass = ''
      let textColor = ''

      if (daysDiff > 30) {
        // More than 30 days - Green
        badgeClass = 'badge-light-success'
        textColor = 'text-success'
      } else if (daysDiff > 0 && daysDiff <= 30) {
        // Less than 30 days but not overdue - Yellow
        badgeClass = 'badge-light-warning'
        textColor = 'text-warning'
      } else {
        // Overdue - Red
        badgeClass = 'badge-light-danger'
        textColor = 'text-danger'
      }

      return (
        <span className={`badge ${badgeClass} ${textColor} fs-7 fw-bold`}>
          {dueDate.toLocaleDateString()}
        </span>
      )


    case "startDatecm":
      const startDate = new Date(parseInt(user.startDate));
      return startDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    // case "endDatecm":
    //   const endDate = new Date(parseInt(user.endDate));
    //   return endDate.toLocaleDateString('en-GB', {
    //     day: '2-digit',
    //     month: '2-digit',
    //     year: 'numeric'
    //   });
    case "endDatecm":
      const endDate = new Date(parseInt(user.endDate));
      const currentDate1 = new Date();
      const isExpired = endDate < currentDate1;

      return (
        <span
          style={{
            backgroundColor: isExpired ? '#FFEEF3' : '#DFFFEA',
            color: isExpired ? '#F8275A' : '#16C653',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: 'bold'
          }}
        >
          {endDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })}
        </span>
      );
    case "createdAtCm":
      const createdDate = new Date(user?.packageInfo?.createdAt);
      return createdDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });

    case 'year':
      return new Date(+user?.[mapData] || new Date()).toLocaleDateString(undefined, {
        year: 'numeric',
      })
    case 'country':
      return user?.pickupPointInfo?.address?.country || ''
    case 'batchId':
      return user.createdAt || ''
    case 'createdAt':
    case 'productionDate':
    case 'supplyDate':
      return user?.[mapData] ? new Date(+user?.[mapData] || new Date()).toLocaleDateString() : '-'
    case 'calibratedOn':
      // case 'nextDue':
      return (
        <span
          className={`badge badge-light-${mapData === 'nextDue' ? 'danger' : 'success'
            } fs-7 fw-bold`}
        >
          {new Date(+user?.[mapData] || new Date()).toLocaleDateString()}
        </span>
      )




    // case 'calibratedOnt':
    //   // case 'nextDue':
    //   return (
    //     <span
    //       className={`badge badge-light-${mapData === 'nextDue' ? 'danger' : 'success'} `}
    //       style={{ color: 'black', fontWeight: 400 }}  // Add this line
    //     >
    //       {new Date(+user?.[mapData] || new Date()).toLocaleDateString()}
    //     </span>
    //   )

    case 'calibratedOnt':
      // case 'nextDue':
      return (
        <span
          className={`badge badge-light-${mapData === 'nextDue' ? 'danger' : 'success'} text-gray-800 text-hover-primary mb-1`}
          style={{ color: 'black', fontWeight: 400, fontSize: "13px" }}  // Add this line
        >
          {new Date(+user?.[mapData] || new Date()).toLocaleDateString()}
        </span>
      )


    case 'nextDue':
      if (!user?.[mapData]) return '-'

      const currentDate = new Date()
      const dueDateTime = new Date(+user?.[mapData])
      const timeDifference = dueDateTime.getTime() - currentDate.getTime()
      const remainingDays = Math.ceil(timeDifference / (1000 * 3600 * 24))

      let backgroundStyle = ''
      let fontColor = ''

      if (remainingDays > 30) {
        // More than 30 days - Green
        backgroundStyle = 'badge-light-success'
        fontColor = 'text-success'
      } else if (remainingDays > 0 && remainingDays <= 30) {
        // Less than 30 days but not overdue - Yellow
        backgroundStyle = 'badge-light-warning'
        fontColor = 'text-warning'
      } else {
        // Overdue - Red
        backgroundStyle = 'badge-light-danger'
        fontColor = 'text-danger'
      }

      return (
        <span
          className={`badge ${backgroundStyle}  `}
          style={{ color: 'black', fontWeight: 400, fontSize: "13px" }}
        >
          {dueDateTime.toLocaleDateString()}
        </span>
      )












    // case 'productionItemDetailsQuantity':
    //   return user['productionItemDetails']?.map((x: any, ind: number) => (
    //     <div key={ind + 1 + ''}>{x.quantity} kg</div>
    //   ))

    // case 'inMaterialDetailsQuantity':
    // case 'productionItemDetailsQuantity':
    //   const quantities = user[
    //     mapData === 'inMaterialDetailsQuantity' ? 'inputMaterial' : 'productionItemDetails'
    //   ]
    //     ?.map(
    //       (x: any) =>
    //         x?.quantity ||
    //         (x?.inputQuantity
    //           ? typeof parseFloat(x.inputQuantity) === 'number'
    //             ? parseFloat(x.inputQuantity).toFixed(2)
    //             : ''
    //           : '') ||
    //         ''
    //     )
    //     .filter(Boolean) // Remove falsy values (null, undefined, 0, etc.)
    //     .join(', ')
    //   // return quantities ? `${quantities?.toFixed(2)} kg` : ''
    //   return quantities ? `${quantities} kg` : ''


    // case 'inMaterialDetailsQuantity':
    // case 'productionItemDetailsQuantity':
    //   const materialSum = user[
    //     mapData === 'inMaterialDetailsQuantity' ? 'inputMaterial' : 'productionItemDetails'
    //   ]?.reduce((sum: number, x: any) =>
    //     sum + (Number(x?.quantity || x?.inputQuantity) || 0), 0
    //   ) || 0;

    //   return `${materialSum.toFixed(2)} kg`;

    case 'inMaterialDetailsQuantity':
    case 'productionItemDetailsQuantity':
      const materialSum = user[
        mapData === 'inMaterialDetailsQuantity' ? 'inputMaterial' : 'productionItemDetails'
      ]?.reduce((sum: number, x: any) =>
        sum + (Number(x?.quantity || x?.inputQuantity) || 0), 0
      ) || 0;

      return Number(materialSum.toFixed(2));



    case 'productionId':
      return user.productionId || ''

    case 'productionId1':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({
              show: true,
              clicked: mapData,
            });
          }}
        >
          {user.productionId}
        </div>
      )








    case 'FormView':
      return (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setshowImageModal({     // ← Change this from setShowMapModal
              show: true,
              clicked: mapData,
            })
          }}
        >
          <KTIcon iconName='eye' className='fs-3' />
        </div>
      )





    case 'productionIdx':
      const productionId = user?.productionId;
      const processDate = user?.actualProcessDate ? user.actualProcessDate.split('T')[0] : '';
      return (
        <div>
          <div style={{ whiteSpace: 'nowrap' }}>{productionId}</div>
          <div style={{
            backgroundColor: '#f5f5f5',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '0.875rem',
            color: '#666',
            marginTop: '4px',
            display: 'inline-block'
          }}>
            {processDate}
          </div>
        </div>
      );



    case "beneficiaryUserType":
      return user.beneficiaryUserType === "CUSTOMER" ? "Household" : user.beneficiaryUserType;

    case "couponType":
      return (
        <span
          style={{
            backgroundColor: user.couponType === 'REWARD' ? '#F8F5FF' : '#DFFFEA',
            color: user.couponType === 'REWARD' ? '#7239EA' : '#16C653',
            padding: '4px 12px',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: '700'
          }}
        >
          {user.couponType}
        </span>
      );


    case "validityDatefull":
      const validityDate = new Date(parseInt(user.validityDate));
      const currentDate2 = new Date();
      const isExpired1 = validityDate < currentDate2;

      return (
        <span
          style={{
            backgroundColor: isExpired1 ? '#FFEEF3' : '#DFFFEA',
            color: isExpired1 ? '#F8275A' : '#16C653',
            padding: '4px 8px',
            borderRadius: '6px',
            fontSize: '13px',
            fontWeight: 'bold'
          }}
        >
          {validityDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          })}
        </span>
      );

    case "retiredQty":
      const retiredQty = user?.retiredQty;
      const categoryName = user?.productionItems?.[0]?.categoryName || '';
      const itemName2 = user?.productionItems?.[0]?.itemName || '';
      const labelText = [categoryName, itemName2].filter(Boolean).join(' • '); // nicely join if both exist

      return (
        <div>
          <div style={{ whiteSpace: 'nowrap' }}>{retiredQty}</div>
          {labelText && (
            <div
              style={{
                backgroundColor: '#f5f5f5',
                padding: '4px 8px',
                borderRadius: '6px',
                fontSize: '0.875rem',
                color: '#666',
                marginTop: '4px',
                display: 'inline-block',
              }}
            >
              {labelText}
            </div>
          )}
        </div>
      );



    case "standradau":
      return user?.auditStandard?.[0]?.name || '-'


    case 'city':
      return user?.address?.city
    case 'cityProvince':
      return user?.address?.city + ' , ' + (user?.address?.state || '')
    case 'pickupPointStaffs':
    case 'pickupPointManagers':
      // return user[mapData]?.map((x: any, ind: number) => <div key={ind + 1 + ''}>{x}</div> || '')
      return user[mapData]?.map((x: any, ind: number) => <div key={ind + 1 + ''}>{x}</div>) || []
    case 'plasticType':
      return user?.productionItemDetails?.map((x) =>
        x?.bomDetails?.map((y) => y?.itemName).join(' , ')
      )
    case 'inMaterials':
    case 'outMaterials':
    case 'inputMaterial':
    case 'productionItemDetails':
      return user[mapData]
        ?.map((x: any) => x?.name || x?.itemName || x?.inputMaterialName)
        .filter(Boolean) // Remove falsy values (like null or undefined)
        .join(', ')
    case 'facilityStaff':
      // return user[mapData]?.map(
      //   (x: any, ind: number) =>
      //     (
      //       <div key={ind + 1 + ''}>
      //         {x?.name === null ? '' : x?.name || x?.itemName || x?.inputMaterialName}
      //       </div>
      //     ) || ''
      // )
      return user[mapData]
        ?.map((x: any) => x?.name || x?.itemName || x?.inputMaterialName)
        .filter(Boolean) // Remove falsy values (like null or undefined)
        .join(', ')

    case 'status_unaudited':
      const statusModify = user?.status || ''
      switch (statusModify) {
        case 'CREATED':
          return <span className='badge badge-primary fs-7 fw-bold'>To Be Issued</span>
        case 'APPROVAL_PENDING':
          return <span className='badge badge-danger fs-7 fw-bold'>Audit Query</span>
        case 'UN_APPROVED':
          return <span className='badge badge-warning fs-7 fw-bold'>Under Audit</span>
        default:
          return ''
      }

    // case 'status':
    //   const statusData = user?.[mapData] || user?.personalDetails?.[mapData]
    //   switch (statusData) {
    //     case 'quantityDeposit':
    //       return <span className='text-primary fs-7 fw-bold'>+28%</span>
    //     case 'COMPLETED':
    //       return <span className='badge badge-light-success fs-7 fw-bold'>Completed</span>
    //     case 'Completed':
    //       return <span className='badge badge-light-success fs-7 fw-bold'>Delivered</span>
    //     case 'APPROVAL_PENDING':
    //       return <span className='badge badge-light-warning fs-7 fw-normal text-black'>Pending</span>
    //     case 'Pickup Completed':
    //     case 'ACCEPTED':
    //       return <span className='badge badge-light-success fs-7 fw-bold'>{statusData}</span>
    //     case 'Rejected':
    //     case 'REJECTED':
    //       return <span className='badge badge-light-danger fs-7 fw-bold'>{statusData}</span>
    //     case 'Created':
    //       return <span className='badge badge-light-warning fs-7 fw-bold'>In transit</span>
    //     case 'CREATED':
    //       return <span className='badge badge-light-warning fs-7 fw-bold'>{statusData}</span>
    //     case 'Accepted':
    //       return <span className='badge badge-light-danger fs-7 fw-bold'>{statusData}</span>
    //     case 'Pickup Assigned':
    //       return <span className='badge badge-light-primary fs-7 fw-bold'>{statusData}</span>

    //     default:
    //       return user?.[mapData] || user?.personalDetails?.[mapData]
    //   }
    case 'dashboardStatus': {
      const dsStatus = user?.status || ''
      const getStatusConfig = (s: string) => {
        switch (s) {
          case 'COMPLETED':
          case 'Completed':
          case 'Pickup Completed':
          case 'ACCEPTED':
            return { label: 'Completed', color: '#15803d', bg: '#dcfce7', icon: '✓' }
          case 'APPROVAL_PENDING':
            return { label: 'Pending', color: '#92400e', bg: '#fef3c7', icon: '⏳' }
          case 'REJECTED':
          case 'Rejected':
            return { label: 'Rejected', color: '#b91c1c', bg: '#fee2e2', icon: '✕' }
          case 'CREATED':
          case 'Created':
            return { label: 'In transit', color: '#1d4ed8', bg: '#dbeafe', icon: '→' }
          case 'Pickup Assigned':
            return { label: 'Assigned', color: '#6d28d9', bg: '#ede9fe', icon: '●' }
          default:
            // return { label: s || '-', color: '#555', bg: '#f3f4f6', icon: '●' }
            return { label: 'Completed', color: '#15803d', bg: '#dcfce7', icon: '✓' }
        }
      }
      const cfg = getStatusConfig(dsStatus)
      return (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            backgroundColor: cfg.bg,
            color: cfg.color,
            borderRadius: '20px',
            padding: '4px 10px',
            fontWeight: '600',
            fontSize: '12px',
            whiteSpace: 'nowrap',
          }}
        >
          <span
            style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              backgroundColor: cfg.color,
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              fontWeight: '700',
              flexShrink: 0,
            }}
          >
            {cfg.icon}
          </span>
          {/* {cfg.label} */}
          Completed
        </div>
      )
    }

    case 'status': {
      const statusData = user?.[mapData] || user?.personalDetails?.[mapData]
      const renderStatusBadge = (label: string, color: string, bg: string, icon: string) => (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            backgroundColor: bg,
            color: color,
            borderRadius: '20px',
            padding: '4px 10px',
            fontWeight: '600',
            fontSize: '12px',
            whiteSpace: 'nowrap',
          }}
        >
          <span
            style={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              backgroundColor: color,
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              fontWeight: '700',
              flexShrink: 0,
            }}
          >
            {icon}
          </span>
          {label}
        </div>
      )
      switch (statusData) {
        case 'quantityDeposit':
          return <span className='text-primary fs-7 fw-bold'>+28%</span>
        case 'COMPLETED':
          return renderStatusBadge('Completed', '#15803d', '#dcfce7', '✓')
        case 'Completed':
          return renderStatusBadge('Delivered', '#15803d', '#dcfce7', '✓')
        case 'APPROVAL_PENDING':
          return renderStatusBadge('Pending', '#92400e', '#fef3c7', '⏳')
        case 'Pickup Completed':
        case 'ACCEPTED':
          return renderStatusBadge(statusData, '#15803d', '#dcfce7', '✓')
        case 'Rejected':
        case 'REJECTED':
          return renderStatusBadge(statusData, '#b91c1c', '#fee2e2', '✕')
        case 'Created':
          return renderStatusBadge('In transit', '#1d4ed8', '#dbeafe', '→')
        case 'CREATED':
          return renderStatusBadge(statusData, '#1d4ed8', '#dbeafe', '→')
        case 'Accepted':
          return renderStatusBadge(statusData, '#b91c1c', '#fee2e2', '✓')
        case 'Pickup Assigned':
          return renderStatusBadge(statusData, '#6d28d9', '#ede9fe', '●')
        default:
          return user?.[mapData] || user?.personalDetails?.[mapData]
      }
    }
    // case 'status':
    //   const statusData = user?.[mapData] || user?.personalDetails?.[mapData]
    //   switch (statusData) {
    //     case 'quantityDeposit':
    //       return <span className='text-primary fs-7 fw-bold'>+28%</span>
    //     case 'COMPLETED':
    //       return <span className='badge badge-light-success fs-7 fw-bold'>Completed</span>
    //     case 'Completed':
    //       return <span className='badge badge-light-success fs-7 fw-bold'>Delivered</span>
    //     case 'APPROVAL_PENDING':
    //       return <span className='badge badge-light-warning fs-7 fw-normal text-black'>Pending</span>
    //     case 'Pickup Completed':
    //     case 'ACCEPTED':
    //       return <span className='badge badge-light-success fs-7 fw-bold'>{statusData}</span>
    //     case 'Rejected':
    //     case 'REJECTED':
    //       return <span className='badge badge-light-danger fs-7 fw-bold'>{statusData}</span>
    //     case 'Created':
    //       return <span className='badge badge-light-warning fs-7 fw-bold'>In transit</span>
    //     case 'CREATED':
    //       return <span className='badge badge-light-warning fs-7 fw-bold text-black'>{statusData}</span>
    //     case 'Accepted':
    //       return <span className='badge badge-light-danger fs-7 fw-bold'>{statusData}</span>
    //     case 'Pickup Assigned':
    //       return <span className='badge badge-light-primary fs-7 fw-bold'>{statusData}</span>
    //     default:
    //       return user?.[mapData] || user?.personalDetails?.[mapData]
    //   }
    default:
      return typeof user[mapData] === 'boolean' ? (
        user[mapData] ? (
          <span className='badge badge-light-success fs-7 fw-bold'>YES</span>
        ) : (
          <span className='badge badge-light-danger fs-7 fw-bold'>NO</span>
        )
      ) : typeof user[mapData] === 'number' ? (
        user?.[mapData] === 0 ? (
          <span className='badge badge-light-danger fs-7 fw-bold'>
            {user?.[mapData]?.toFixed()}
          </span>
        ) : (
          user?.[mapData]?.toFixed() || user?.personalDetails?.[mapData]?.toFixed() || ''
        )
      ) : (
        clipText(user?.[mapData], 25) || clipText(user?.personalDetails?.[mapData], 25) || ''
      )
  }
}
function clipText(text, maxLength = 25, clipper = '...') {
  if (!text) return text
  return text.length > maxLength ? text.slice(0, maxLength - clipper.length) + clipper : text || '-'
}
